import React, { FC, useState, useMemo, useEffect, useRef } from 'react';
import moment from 'moment';
import { useSetState } from 'ahooks';
import { isEqual, uniq, set } from 'lodash-es';
import { Modal, Button, Form, Radio } from 'tea-component';
import InputNumber from '@/pages/intelligence/components/Form/components/common/InputNumber';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import aegisLog from '@/log/aegis';
import { isEmpty } from '@intelligence/v3/utils/common';
import {
  isSafari,
  getDataSourceMetrics,
  getDownloadFileName,
  ifHasSteam,
  commonFilterDevice,
  commonFilterSegment,
  getAlineaCalibrationSourceMetrics,
} from '../../utils';
import { DownLoadConfig } from '../../instance/config';
import { getDownloadTaskId } from '../../../../services/download';
import CustomForm, {
  getCascaderDeviceValue,
  getCascadeOptionsNew,
} from '../CustomForm';
import AutoFormControlText from '../AutoFormControlText';
import {
  BusinessType,
  BusinessFormType,
  DownloadSettingModalProps,
} from '../../types';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { PcConsoleNewParams } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/constant';
import {
  FILE_FORMATS,
  EXPORT_ALL_DATA_AMOUNTS,
  DATA_AMOUNTS,
  DATA_AMOUNTS_CHECKED,
  SELECT_TOP,
  DOWNLOAD_TITLE_TIPS,
  getStatsMetric,
  OrderMetricsMap,
  NEWZOO_WEIGHT_METRICS,
  ORDER_METRICS_MAP_DETAIL,
  FOLLOWING_CURRENTGAME_METRICS,
  DATA_AMOUNTS_ALL_AND_CHECKED,
  // FOLLOWING_NEWGAME_METRICS,
} from '../../instance/const';
import { toDateTypeLy } from '@/pages/intelligence/utils/common';
import {
  hasFollowingRetentionForDownload,
  FOLLOWING_RETENTION_DN_METRICS,
} from '@/pages/intelligence/pages/Following/_config/util';
import { getBasePath, storage } from '@/utils/utils';
import { analysisPlatformTopInfo } from '@/pages/intelligence/_config/storeRank/utils';
import {
  MOBILE_STORE_RANK_TOPS_NAMES_MAPPING,
  PC_STORE_RANK_TOPS_NAMES_MAPPING,
  CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING,
} from '@/pages/intelligence/_config/storeRank/config';
import {
  // analysisDataSourceMetricKey,
  generateDataSourceMetricKey,
} from '@intelligence/utils/topchartsUtils';
import { getServerDataSourceOfCombineMetricsTable } from '@intelligence/pages/TopCharts/PCConsoleGames/utils';
import { tranFormSenorTowerTagParam } from '@/pages/intelligence/utils/topchartsUtils';
import { tranFormRevenueRangeParams } from '@/pages/intelligence/pages/TopCharts/Companies/utils';
import { GSD_SOURCE_KEY } from '@intelligence/_config/sourceMetric';
import { DEVICE_DETAIL_DISABLED_MESSAGE } from '@intelligence/pages/TopCharts/PCGames/_config/constantDownload';
import GsdIcon from '@intelligence/assets/svg/dataSource/gsd-icon.svg';
import InfoDoc from '@intelligence/_locales/en-US/infoDoc';
import InfoDocCN from '@intelligence/_locales/zh-CN/infoDoc';
import {
  changeMetricSelector,
  deleteVgiWeightPriceOption,
  getAllMetricsDeatilDefaultMetrics,
  getCombineDetailDefaultMetrics,
  buildOrderMetricsFromSelectorValues,
  buildOrderMetricsFromDetailSelectorValues,
  buildOrderMetricsFromPageMetricValues,
  toDetailMetricSelectorValues,
  findOptionByType,
  resolvePcConsoleSelectorMetricKey,
} from './utils';
import { getOrderedMetricEntriesFromParams } from '@intelligence/components/DownloadCommon/DownloadPage/utils/reorderCombineDetailDownloadMetrics';
import {
  getMobileStatsDownloadDateTypeList,
  getMobileStatsRetentionDownloadTabDefaults,
  isMobileStatsMetricDownloadBusiness,
  patchMobileRetentionStatsDownloadFormList,
  sanitizeMobileRetentionStatsDownloadPatch,
} from './mobileRetentionStatsDownloadForm';
import { downloadAction } from '@intelligence/components/DownloadCommon/DownloadPage';
import { TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { appendAdjustedRevenueFilter } from '@intelligence/utils/revenueScope';
import {
  PCConsoleSegementList,
  PCConsoleDataBrainSegementList,
} from '@intelligence/pages/TopCharts/_config/metricOptions';
import { MINI_GAME_RANKING_KEY_LIST_DOUYIN } from '@intelligence/v3/pages/ReusePages/CasualMiniGameRankings/config';
import { allMetricsOptions } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection/config';
import './index.scss';

const { pcConsoleCascaderMetricsMap } = PCConsoleSegementList;
const { pcConsoleCascaderMetricsMap: pcConsoleDataBrainCascaderMetricsMap } =
  PCConsoleDataBrainSegementList;

const DATE_TYPE_VALUES = ['daily', 'weekly', 'monthly'];
const whiteListDownloadKey = [
  'mobileStoreRankMore',
  'consoleStoreRankMore',
  'mobileStoreRankTop',
  'consoleStoreRankTop',
];
const DOWNLOAD_AMOUNT_TYPE_GAME = 'game';
const DOWNLOAD_AMOUNT_TYPE_TIME = 'time';
const DOWNLOAD_AMOUNT_TYPE_LIST = [
  {
    label: 'dbi_download_type_by_game',
    tip: 'dbi_download_type_by_game_tip',
    value: DOWNLOAD_AMOUNT_TYPE_GAME,
  },
  {
    label: 'dbi_download_type_by_time',
    tip: 'dbi_download_type_by_time_tip',
    value: DOWNLOAD_AMOUNT_TYPE_TIME,
  },
];
const RETENTION_MONTHLY_DATA_AI_SEGMENT = 'retention—retention_monthly';
const RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT = 'retention—retention_monthly_sensortower';
const RETENTION_LIFETIME_SEGMENT = 'retention—retention_lifetime';

const getMobileRetentionDataSources = (
  segment?: string,
  source?: string | string[],
  dataSources?: string[],
) => {
  if (
    segment === RETENTION_MONTHLY_SENSOR_TOWER_SEGMENT ||
    segment === RETENTION_LIFETIME_SEGMENT
  ) {
    return ['sensortower'];
  }
  if (segment === RETENTION_MONTHLY_DATA_AI_SEGMENT) {
    return ['appannie'];
  }
  if (Array.isArray(source) && source.length) {
    return source;
  }
  if (typeof source === 'string' && source) {
    return [source];
  }
  if (Array.isArray(dataSources) && dataSources.length) {
    return dataSources;
  }
  return ['appannie'];
};

// 转换函数
function transformData(data) {
  try {
    const newData = JSON.parse(JSON.stringify(data));
    const elementsToMove = ['steamfollowers', 'steamreviews'];

    elementsToMove.forEach((element) => {
      if (Array.isArray(newData.steamcharts)) {
        const index = newData.steamcharts.indexOf(element);
        if (index !== -1) {
          // 从steamcharts移除
          newData.steamcharts.splice(index, 1);
          // 检查newData.vginsights是否为数组，不是则初始化为数组
          newData.vginsights = Array.isArray(newData.vginsights)
            ? newData.vginsights
            : [];
          // 添加到vginsights
          newData.vginsights.push(element);
        }
      }
    });

    return newData;
  } catch (err) {
    console.error('An error occurred during data transformation:', err);
    return data; // if an error occurred return the original data
  }
}

// 需要把boolean类型的value 转为为 1、0的 字段
const BOOLEAN_2_NUM_FIELDS = [
  'region_show',
  'genre_show',
  'company_show',
  'publisher_class_show',
  'release_date_show',
  'ratio_show',
  'games_owned_show',
  'ipo_status_show',
  'headquaters_show',
  'game_type_show',
  'lang_region_show',
  'url_show',
  'sensortower_tags_show',
];

/**
 * 把下载表单对象中的指定的value为boolean类型的字段 转换为 1、0
 * @param data 下载表单对象
 * @param fields 需要把boolean转换为1（true）、0（false）的字段列表列表
 */
const convertBoolean2Num = (data: any, fields: string[]) => {
  if (Object.prototype.toString.call(data) !== '[object Object]') return;
  if (!Array.isArray(fields)) return;

  for (const field of fields) {
    if (!Reflect.has(data, field)) continue;
    const fieldValue = Reflect.get(data, field);
    if (typeof fieldValue !== 'boolean') continue;
    Reflect.set(data, field, fieldValue ? 1 : 0);
  }
};

/**
 * 通过 Metrics 选项框顺序给 download_metrics 排序
 * @param data 下载表单对象
 * @param formList 表单展示项，从中筛选出 metrics options
 */
const sortDownloadMetricsByOptionsOrder = (
  data: any,
  formList: { field: string; options: []; }[],
) => {
  const metricsOptions = formList.find(
    (item) => item.field === 'download_metrics',
  )?.options;

  if (!metricsOptions?.length) return;

  // 获取选项顺序 map
  const metricsOptionsOrderMap = metricsOptions?.reduce(
    (prev: Record<string, number>, curr: { value: string; }, index: number) => {
      prev[curr.value] = index;
      return prev;
    },
    {},
  );

  // metrics 指标排序
  data.download_metrics.sort(
    (a: string, b: string) =>
      metricsOptionsOrderMap[a] - metricsOptionsOrderMap[b],
  );
};

// interface IDevicesReq {
//   npd: string[];
//   mscience: string[];
//   famitsu: string[];
//   newzoo: string[];
//   [key: string]: string[];
// }
// const convertDevicesOfCascaderDevices = (devices: string[]): IDevicesReq => {
//   const devicesReq: IDevicesReq = {
//     npd: [],
//     mscience: [],
//     vginsights: [],
//     famitsu: [],
//     newzoo: [],
//     [GSD_SOURCE_KEY]: [],
//   };
//   if (!Array.isArray(devices)) return devicesReq;
//   for (const device of devices) {
//     if (!device) continue;
//     const { dataSource, metric } = analysisDataSourceMetricKey(device);
//     const dataSourceDevices = devicesReq[dataSource];
//     if (!dataSourceDevices) continue;
//     if (dataSourceDevices.includes(metric)) continue;
//     dataSourceDevices.push(metric);
//   }
//   return devicesReq;
// };

/**
 * 合并其他数据源的device的options集合、GSD数据源的device的options集合
 * @param deviceSources 其他数据源的集合
 * @param gsdDeviceOptions GSD数据源
 * @returns
 */
const composeDeviceOptionsAndGsdDeviceOptions = <T extends Record<string, any>>(
  deviceSources?: T[],
  gsdDeviceSource?: T,
): T[] => {
  // 数据异常，返回空数组
  if (!Array.isArray(deviceSources) && !gsdDeviceSource) return [];
  // GSD数据源的device的options集合异常，直接返回其他数据源的device的options集合
  if (!gsdDeviceSource) return deviceSources as T[];
  // 其他数据源的device的options集合异常，直接返回GSD数据源的device的options集合
  if (!Array.isArray(deviceSources)) return [gsdDeviceSource];
  // 其他数据源的device的options集合、GSD数据源的device的options集合 都是正常数据，进行组合，GSD数据源放在Mscience数据源的前面
  const mscienceDeviceSourceIdx = deviceSources.findIndex(
    (item) => item?.value === 'mscience',
  );
  if (mscienceDeviceSourceIdx === -1)
    return [...deviceSources, gsdDeviceSource];
  return [
    ...deviceSources.slice(0, mscienceDeviceSourceIdx),
    gsdDeviceSource,
    ...deviceSources.slice(mscienceDeviceSourceIdx),
  ];
};

/**
 * 更新表单控件的options的disabled状态、defaultValue（仅更新级联指标筛选器表单控件）
 * @param controls 表单控件集合
 * @param payload.pageId 页面Id
 * @param payload.tableParams 页面传入的榜单入参
 * @returns 表单控件集合（更新表单控件的options的disabled状态、defaultValue）（仅更新级联指标筛选器表单控件）
 */
const updateCascaderMetricOptionsDisabledStateAndDefaultValue = (
  controls?: any[],
  payload?: {
    pageId?: string;
    tableParams?: Record<string, any>;
  },
): any[] => {
  if (!Array.isArray(controls) || !controls.length) return [];
  return controls.map((control) => {
    // 非级联指标筛选器控件 不做更新
    if (
      control?.type === 'sourceMetricSelectorDetail' ||
      control?.type === 'cascadeMetricSelector'
    ) {
      const cascadeOptions = getCascadeOptionsNew(control?.cascadeOptions, {
        ifUseMetricsMap: control?.ifUseMetricsMap || false,
        pageId: payload?.pageId,
        tableParams: payload?.tableParams,
      });
      let defaultValue: [string, string][] = control?.defaultValue;
      // defaultValue不是配置的全选时（即配置为[['All', 'All']]），需要处理value的有效性
      if (!isEqual([['All', 'All']], defaultValue)) {
        // 处理defaultValue，在原有defaultValue配置的基础上仅保留能匹配上选项option的 并且 匹配上的option非禁用的
        defaultValue = control?.defaultValue?.filter(
          (dataSourceMetricValue: [string, string]) => {
            const [dataSource, metric] = dataSourceMetricValue || [];
            const cascadeOption = cascadeOptions?.find(
              (cascadeOption) => cascadeOption?.value === dataSource,
            );
            // 当前value的数据源没匹配到cascadeOption 或者 当前value的数据源匹配的cascadeOption是禁用的，过滤掉当前value
            if (!cascadeOption || cascadeOption?.disabled) return false;
            const subCascadeOption = cascadeOption.children?.find(
              (subCascadeOption: any) => subCascadeOption?.value === metric,
            );
            return subCascadeOption && !subCascadeOption?.disabled;
          },
        );
      }
      return {
        ...control,
        cascadeOptions: cascadeOptions || [],
        defaultValue: defaultValue || [],
      };
    }
    return { ...control };
  });
};

const STORE_RANK_TOP_BUSINESS_TYPES = [
  'mobile-store-rank-top',
  'pc-steam-store-rank-top',
  'pc-epic-store-rank-top',
  'console-ps-store-rank-top',
  'console-xbox-store-rank-top',
  'console-nintendo-store-rank-top',
];

const STORE_RANK_TOP_NAME_MAPPING: Record<string, Record<string, string>> = {
  mobile: MOBILE_STORE_RANK_TOPS_NAMES_MAPPING,
  pc: PC_STORE_RANK_TOPS_NAMES_MAPPING,
  console: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING,
};

const getStoreRankTopRankingOptions = (
  entityType: string,
  rankingSources: string[] = [],
) => {
  if (!Array.isArray(rankingSources) || !rankingSources.length) {
    return [];
  }
  const topNamesMapping = STORE_RANK_TOP_NAME_MAPPING[entityType] || {};
  return rankingSources.map((source) => {
    const { platform, top } = analysisPlatformTopInfo(source);
    return {
      value: source,
      label: topNamesMapping[top] || top,
      source: platform,
    };
  });
};

const injectStoreRankTopRankingOptions = (
  list: any[],
  tableParams: any,
  entityType: string,
) => {
  const options = getStoreRankTopRankingOptions(
    entityType || tableParams?.entity_type,
    tableParams?.rankingSources,
  );
  return list.map((item) => {
    if (item?.field !== 'sources') {
      return { ...item };
    }
    return {
      ...item,
      options,
    };
  });
};

const DownloadSettingModal: FC<DownloadSettingModalProps> = (props) => {
  const { formatMessage, locale } = useIntlExtend();
  const {
    total = 0,
    visible,
    loading,
    entityType,
    businessType,
    setLoading,
    setModalVisible,
    downloadModalSize,
    downloadLogConfigKey,
    classModalName,
    downloadTitle = formatMessage({ id: 'dbi_download_settings' }),
    isDisableDataAmount = false,
    tableParams = {},
    isShowMaxDownloadRowsTips,
    downloadTitleTips = DOWNLOAD_TITLE_TIPS,
    maxSize,
    // maxSize = 5000,
    segpaVa,
    isShowExportAllDataTip = false, // 是否展示ExportAll的提示
    isOnlyExportAllData = false,
    isNeedCheckedLines = false,
    isAllAndChecked = false,
    defaultCheckedLines = false,
    isGameTopCharts = false,
    isCalibrated = false,
    isSyncPageSizeWithSelectTop = false,
    useDownloadAmountType = false,
    texts,
    getCheckedLinesCfg,
    dataType,
    regionOptions,
    excelName,
    pageId,
    newStyleFileName,
    gsdDevicesFlatten,
    gsdSegments,
    downloadLogConfig,
    isStudio,
    metricSelectorOptions,
    tabType,
    isCoutriesPage = false,
    useWebDownload = false,
    downloadKey = '',
    downloadQuery,
    stickText,
    hideStickText,
    dataSource = 'sensortower',
    getSortedGameIds,
    downloadPageFun,
  } = props;

  console.debug('DownloadSettingModal', props);

  // 是否开启翻译功能
  const translate = DownLoadConfig[businessType]?.translate ?? false;

  const isMobileStatsMetricDownloadScene = useMemo(
    () => isMobileStatsMetricDownloadBusiness(businessType),
    [businessType],
  );

  const cascaderDeviceValueList = useRef<any>(null);

  const isMetricsTable = [
    'pc-MetricsTable',
    'console-MetricsTable',
    'combine-PCConsoleMetricsTable',
    'combine-PCConsoleMetricsTable-studio',
    'pc-console-topCharts',
    'databrain-calibration-pc-console-topCharts',
    'alinea-analytics-calibration-pc-console-topCharts',
  ].includes(businessType);

  // 自动兼容开启翻译、未开启翻译
  const formatMessageSafelyAuto = (option: { id: string }) => {
    if (!translate) return option?.id ?? '';
    return formatMessage(option);
  };

  const [disabledGsd, setDisabledGsd] = useState(false);
  const [disabledFamitsu, setDisabledFamitsu] = useState(false);
  const [disabledNpd, setDisabledNpd] = useState(false);
  const [disabledRatio, setDisabledRatio] = useState(false);
  const [disabledMscience, setDisabledMscience] = useState(false);

  const DefaultDataMethod = useMemo(() => {
    if (isOnlyExportAllData) {
      return 'selectAll';
    }

    switch (businessType) {
      case 'combine-PCConsoleMetricsTable':
      // case 'combine-PCConsoleMetricsTable-studio':
      case 'pc-console-topCharts':
      case 'databrain-calibration-pc-console-topCharts':
      case 'alinea-analytics-calibration-pc-console-topCharts':
      case 'mobile-activeuser':
      // case 'mobile-activeuser-studio':
      case 'mobile-revenue':
      case 'mobile-downloads':
      case 'mobile-rpd':
      case 'mobile-demographics':
      case 'mobile-upcoming':
        return 'selectTop';
      default:
        return defaultCheckedLines && isNeedCheckedLines
          ? 'checkedLines'
          : 'selectAll';
    }
  }, [businessType, defaultCheckedLines, isNeedCheckedLines, isOnlyExportAllData]);

  const initialSelectTop = useMemo(() => {
    if (STORE_RANK_TOP_BUSINESS_TYPES.includes(businessType)) {
      return 10;
    }
    let initialValue: number;
    switch (businessType) {
      case 'combine-PCConsoleMetricsTable':
      // case 'combine-PCConsoleMetricsTable-studio':
      case 'pc-console-topCharts':
      case 'databrain-calibration-pc-console-topCharts':
      case 'mobile-activeuser':
      case 'mobile-revenue':
      case 'mobile-downloads':
      case 'mobile-rpd':
      case 'mobile-upcoming':
      case 'mobile-retention':
      case 'mobile-demographics':
        initialValue = 100;
        break;
      case 'alinea-analytics-calibration-pc-console-topCharts':
        initialValue = 10;
        break;
      default:
        initialValue = total > SELECT_TOP ? SELECT_TOP : total;
    }

    if (initialValue > total) {
      return total;
    }

    return initialValue;
  }, [businessType, total]);

  // 根据参数判断是否走新下载页面
  const getUseWebDownloadCur = (params: any) => {
    if (useWebDownload) {
      return true;
    }
    switch (businessType) {
      // case 'marketProfile-stats': {
      //   if (params.entity_type === 'mobile') {
      //     return true;
      //   }
      //   return false;
      // }
      // case 'genre-profile-detail':
      case 'genre-profile-detail': {
        if (params.entity_type === 'mobile') {
          return true;
        }
        return false;
      }
      case 'genre-profile': {
        if (params.entity_type === 'mobile' || params.entity_type === 'total') {
          return true;
        }
        return false;
      }
      default:
        return false;
    }
  };

  // const initialSelectTop = businessType === 'combine-PCConsoleMetricsTable' ? 100 : total > SELECT_TOP ? SELECT_TOP : total;
  const [formModel, setFormModelState] = useSetState<BusinessFormType>({
    data_method: DefaultDataMethod,
    data_amount: initialSelectTop,
    select_top_type: DOWNLOAD_AMOUNT_TYPE_TIME,
    file_format: '0',
  });

  const [isBlur, setIsBlur] = useState(false);
  useEffect(() => {
    const arrTemp = formModel?.metrics || [];
    const arr = arrTemp.map((item: any) => item[0]);

    const msBoGsd = arr?.findIndex((item: any) => item === GSD_SOURCE_KEY) > -1;
    const msBoMscience = arr.findIndex((item: any) => item === 'Mscience') > -1;
    const msBoNpd = arr.findIndex((item: any) => item === 'npd') > -1;
    const msBoFamitsu = arr.findIndex((item: any) => item === 'famitsu') > -1;

    setDisabledGsd(!msBoGsd);
    setDisabledFamitsu(!msBoFamitsu);
    setDisabledNpd(!msBoNpd);
    setDisabledMscience(!msBoMscience);
  }, [tableParams.entity_type, tableParams.currentMetric, formModel?.metrics]);

  const getSource_metrics = (params: any, businessType?: BusinessType) => {
    if (!params) return {};

    let sourceMetrics = params.metrics?.reduce((acc: any, cur: string[]) => {
      if (!cur || !Array.isArray(cur) || (cur as string[]).length < 2)
        return acc;
      // eslint-disable-next-line prefer-const
      let [dataSource, metric] = cur;

      if (
        typeof businessType === 'string' &&
        businessType?.includes('combine')
      ) {
        dataSource = getServerDataSourceOfCombineMetricsTable(
          dataSource,
          metric,
        );
      }
      // 指标展示仍可在某个分组下（例如 Steam / VGI），但入参需要归到 gamalytic：
      // - 下载弹窗的分组 value 会成为 source_metrics 的 key
      // - gamalytic__* 指标属于 gamalytic 数据源
      if (typeof metric === 'string' && metric.startsWith('gamalytic__')) {
        dataSource = 'gamalytic';
      }
      // source_steam__* 指标（如 source_steam__pcu/source_steam__acu）在 UI 上挂在 Steam 分组下，
      // 但后端入参需要归到 source_steam 数据源 key
      if (typeof metric === 'string' && metric.startsWith('source_steam_')) {
        dataSource = 'source_steam';
      }
      // alinea__* 指标在 UI 上挂在 Source Steam 分组（value=source_steam）下，
      // 但后端入参需要归到 alinea 数据源 key
      if (typeof metric === 'string' && metric.startsWith('alinea__')) {
        dataSource = 'alinea';
      }
      // steamfollowers / steamreviews 在 UI 上可能挂在 Steam 分组（value=source_steam）或 VGI Steam Data 分组（value=vginsights）下，
      if (metric === 'steamfollowers') {
        dataSource = 'vginsights';
      }
      // console.log('getSource_metrics-dataSource', dataSource);

      if (!acc[dataSource]) {
        acc[dataSource] = [];
      }
      // newzoo 部分指标 是 加权指标，数据源 要由 newzoo 改为 newzoo_weight
      if (NEWZOO_WEIGHT_METRICS.includes(metric)) {
        const weightDataSourceKey = `${dataSource}_weight`;
        if (!acc[weightDataSourceKey]) {
          acc[weightDataSourceKey] = [];
        }
        acc[weightDataSourceKey].push(metric);
      } else {
        acc[dataSource].push(metric);
      }
      return acc;
    }, {});

    // eslint-disable-next-line no-prototype-builtins
    if (sourceMetrics.hasOwnProperty('steam')) {
      sourceMetrics = { ...sourceMetrics, steamcharts: sourceMetrics.steam };
      delete sourceMetrics.steam;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (sourceMetrics.hasOwnProperty('Mscience')) {
      sourceMetrics = { ...sourceMetrics, mscience: sourceMetrics.Mscience };
      delete sourceMetrics.Mscience;
    }
    return sourceMetrics;
  };

  const getCompanyDetailMetrics = (metrics: any) => {
    const arrTemp = [];
    for (const n in metrics) {
      if (metrics[n][0] === 'PC Metrics') {
        if (metrics[n][1] === 'pc_digitalRevenue') {
          arrTemp.push('pc_digitalRevenue', 'pc_units');
        } else if (metrics[n][1] === 'pc_pcu') {
          arrTemp.push('pc_pcu', 'pc_acu');
        } else {
          arrTemp.push(metrics[n][1]);
        }
      } else if (metrics[n][0] === 'Console Metrics') {
        if (metrics[n][1] === 'console_digitalRevenue') {
          arrTemp.push('console_digitalRevenue', 'console_units');
        } else {
          arrTemp.push(metrics[n][1]);
        }
      } else if (metrics[n][0] === 'gameOwned') {
        arrTemp.push(metrics[n][0]);
      } else {
        arrTemp.push(metrics[n][1]);
      }
    }
    return arrTemp;
  };

  const openCommonDownloadPage = async (params: any) => {
    // 榜单页 demographics sensortower 直接文件流下载
    if (businessType === 'mobile-demographics' && params?.source === 'sensortower') {
      try {
        setLoading(true);
        storage.setItem('dbi_mobile_rank_demographics_download_params', { businessType, params });
        if (isSafari()) {
          const page: any = window.open('', '_blank');
          page.location = `${location.origin}${getBasePath()}/intelligence/download?entityType=${entityType}&isShowMaxDownloadRowsTips${isShowMaxDownloadRowsTips}`;
        } else {
          window.open(
            `${getBasePath()}/intelligence/download?entityType=${entityType}&isShowMaxDownloadRowsTips=${isShowMaxDownloadRowsTips}`,
            '_blank',
          );
        }
      } catch (e) {
        console.warn(e);
      } finally {
        setLoading(false);
        setModalVisible(false);
      }
      return;
    }
    // 详情页 demographics sensortower 直接文件流下载
    if (businessType === 'mobile-detail-demographics' && params?.datasource === 'sensortower') {
      try {
        setLoading(true);
        storage.setItem('dbi_mobile_details_demographics_download_params', { businessType, params });
        if (isSafari()) {
          const page: any = window.open('', '_blank');
          page.location = `${location.origin}${getBasePath()}/intelligence/download?entityType=${entityType}&isShowMaxDownloadRowsTips=${isShowMaxDownloadRowsTips}`;
        } else {
          window.open(
            `${getBasePath()}/intelligence/download?entityType=${entityType}&isShowMaxDownloadRowsTips=${isShowMaxDownloadRowsTips}`,
            '_blank',
          );
        }
      } catch (e) {
        console.warn(e);
      } finally {
        setLoading(false);
        setModalVisible(false);
      }
      return;
    }
    // 非 sensortower 下载时，及时清理旧的 sessionStorage
    if (businessType === 'mobile-detail-demographics') {
      storage.removeItem('dbi_mobile_details_demographics_download_params');
    }
    // 非 sensortower 下载时，及时清理旧的 sessionStorage
    if (businessType === 'mobile-demographics') {
      storage.removeItem('dbi_mobile_rank_demographics_download_params');
    }

    try {
      setLoading(true);
      const api = DownLoadConfig?.[businessType]?.apiUrl || '';
      if (!api) return;
      if (isSafari()) {
        const page: any = window.open('', '_blank');
        const taskId = await getDownloadTaskId(api, params);
        page.location = `${location.origin
          }${getBasePath()}/intelligence/download?entityType=${entityType}&taskId=${taskId}&isShowMaxDownloadRowsTips${isShowMaxDownloadRowsTips}`;
      } else {
        const taskId = await getDownloadTaskId(api, params);
        window.open(
          `${getBasePath()}/intelligence/download?entityType=${entityType}&taskId=${taskId}&isShowMaxDownloadRowsTips=${isShowMaxDownloadRowsTips}`,
          '_blank',
        );
      }
    } catch (e) {
      console.warn(e);
    } finally {
      setLoading(false);
      setModalVisible(false);
    }
  };

  const handleDownloadLog = (logConfigKey?: string) => {
    // @ts-ignore
    const logConfig = dbiBtnLogMes[logConfigKey];
    downloadLogConfig && buriedBtnPoint(downloadLogConfig);
    if (!logConfig) return;
    buriedBtnPoint(logConfig);
  };

  const getSelectIds = (gameList: any[]) =>
    gameList?.map((item: any) => item.id || item.gameId);

  // 下载按时间粒度聚合时，下载的时间粒度要跟榜单查询传的时间粒度保持一致
  const handleDownloadDateTypes = (
    params: { [key: string]: any; },
    cfg: {
      // 下载时，按时间计算方式（按时间聚合、按时间拆分）
      downloadDateMethodKey: string;
      // 下载时，时间粒度列表
      downloadDateTypesKey: string;
      // 榜单查询数据的时间粒度
      dateTypeKey: string;
    },
  ) => {
    if (!params) return;
    const { downloadDateMethodKey, downloadDateTypesKey, dateTypeKey } =
      cfg || {};
    if (Reflect.has(params, downloadDateTypesKey)) {
      if (params?.[downloadDateMethodKey] === 'aggregated') {
        const dateType = params?.[dateTypeKey];
        params[downloadDateTypesKey] = dateType ? [dateType] : [];
      }
    }
  };

  const handleDownload = async () => {
    if (
      !STORE_RANK_TOP_BUSINESS_TYPES.includes(businessType) &&
      formModel?.data_amount > Number(total)
    ) {
      formModel.data_amount = Number(total);
    }
    const dataAmount = !isDisableDataAmount
      ? {
        select_top:
          formModel?.data_method === 'selectTop'
            ? formModel?.data_amount
            : Number(total),
      }
      : {};
    if (isOnlyExportAllData) {
      dataAmount.select_top = Number(total);
    }
    if (
      whiteListDownloadKey.includes(downloadKey) &&
      formModel?.data_method == 'selectAll'
    ) {
      dataAmount.select_top = 0;
    }
    let params: any = {
      ...tableParams,
      ...formModel,
      ...dataAmount,
      regionOptions: regionOptions ?? tableParams?.regionOptions,
      file_format: Number(formModel?.file_format),
      file_name: excelName || '',
      // 新风格全局排查文件名规范
      new_style_donwload_file_name: getDownloadFileName(
        businessType,
        newStyleFileName || '',
        entityType,
      ),
    };
    convertBoolean2Num(params, BOOLEAN_2_NUM_FIELDS);
    // MetricsTable 下载列顺序与页面表格列顺序一致，不按 options 静态顺序重排
    if (!isMetricsTable) {
      sortDownloadMetricsByOptionsOrder(params, formList);
    }
    if (isSyncPageSizeWithSelectTop) {
      params.page_size = params.select_top;
    }
    if (isShowDownloadAmountType) {
      params.select_top_type =
        formModel?.select_top_type || DOWNLOAD_AMOUNT_TYPE_TIME;
    } else {
      delete params.select_top_type;
    }

    switch (businessType) {
      case 'mobile-stats-retentionmonthly':
      case 'mobile-stats-retentionlifetime':
        // eslint-disable-next-line no-case-declarations
        let mobileDataSources =
          Array.isArray(formModel?.data_sources) && formModel.data_sources.length > 0
            ? formModel.data_sources
            : getMobileRetentionDataSources(
                tableParams?.segment,
                tableParams?.source,
                tableParams?.data_sources,
              );
        if (ifHasSteam(formModel?.metric ?? [])) {
          mobileDataSources = [...mobileDataSources, 'stream'];
        }
        params = {
          ...params,
          metric: formModel?.metric,
          date_type_list: getMobileStatsDownloadDateTypeList(
            formModel?.metric,
            formModel?.downlaod_date_method === 'aggregated'
              ? [params?.date_type]
              : formModel?.download_date_type,
          ),
          date_method: formModel?.downlaod_date_method,
          platform: ['facebook', 'ytg', 'twitch'],
          data_sources: mobileDataSources,
        };
        delete params?.download_date_type;
        delete params?.downlaod_date_method;
        break;
      case 'mobile-stats-countries':
      case 'mobile-stats-countries-rpd':
        // eslint-disable-next-line no-case-declarations
        let mobileDataSourcesValue =
          formModel?.data_sources || tableParams?.data_source || [];
        if (ifHasSteam(formModel?.metric ?? [])) {
          mobileDataSourcesValue = [...mobileDataSourcesValue, 'stream'];
        }
        params = {
          ...params,
          metric: formModel?.metric,
          date_type_list: getMobileStatsDownloadDateTypeList(
            formModel?.metric,
            formModel?.downlaod_date_method === 'aggregated'
              ? [params?.date_type]
              : formModel?.download_date_type,
          ),
          date_method: formModel?.downlaod_date_method,
          platform: ['facebook', 'ytg', 'twitch'],
          data_sources: mobileDataSourcesValue,
        };
        if (businessType === 'mobile-stats-countries') {
          if (tableParams?.segment === 'revenue') {
            params = appendAdjustedRevenueFilter(params, params?.revenue_scope);
            delete params?.adjusted_revenue;
          }
        }
        delete params?.download_date_type;
        delete params?.downlaod_date_method;
        break;
      case 'mobile-rpd':
        params = {
          ...params,
          // download_date_type: [toDateTypeLy[params?.date_type]],
          region_show: formModel?.region_show ? 1 : 0,
          genre_show: formModel?.genre_show ? 1 : 0,
          company_show: formModel?.company_show ? 1 : 0,
          release_date_show: formModel?.release_date_show ? 1 : 0,
          data_source: formModel?.data_sources,
        };
        handleDownloadDateTypes(params, {
          downloadDateMethodKey: 'downlaod_date_method',
          downloadDateTypesKey: 'download_date_type',
          dateTypeKey: 'date_type',
        });
        params = tranFormSenorTowerTagParam(params);
        break;
      case 'mobile-retention': {
        const retentionDataSource = Array.isArray(formModel?.data_sources)
          ? formModel.data_sources[0]
          : formModel?.data_sources || tableParams?.data_source || 'sensortower';
        params = {
          ...params,
          ratio_show: formModel?.ratio_show ? 1 : 0,
          region_show: formModel?.region_show ? 1 : 0,
          genre_show: formModel?.genre_show ? 1 : 0,
          company_show: formModel?.company_show ? 1 : 0,
          release_date_show: formModel?.release_date_show ? 1 : 0,
          edition_method: formModel?.edition_method?.[0],
          platform: tableParams?.platforms || ['appstore', 'googleplay'],
          download_devices: [],
          data_source: retentionDataSource,
        };
        handleDownloadDateTypes(params, {
          downloadDateMethodKey: 'downlaod_date_method',
          downloadDateTypesKey: 'download_date_type',
          dateTypeKey: 'date_type',
        });
        params = tranFormSenorTowerTagParam(params);
        break;
      }
      case 'mobile-activeuser':
      case 'mobile-databrain':
      case 'mobile-downloads':
      case 'mobile-revenue':
      case 'mobile-demographics':
      case 'mobile-activeuser-studio':
        params = {
          ...params,
          ratio_show: formModel?.ratio_show ? 1 : 0,
          region_show: formModel?.region_show ? 1 : 0,
          genre_show: formModel?.genre_show ? 1 : 0,
          company_show: formModel?.company_show ? 1 : 0,
          release_date_show: formModel?.release_date_show ? 1 : 0,
          game_engine_show: formModel?.game_engine_show ? 1 : 0,
          platform: tableParams?.platforms,
          platforms:
            businessType === 'mobile-activeuser' ||
              businessType === 'mobile-activeuser-studio' ||
              businessType === 'mobile-downloads' ||
              businessType === 'mobile-revenue' ||
              businessType === 'mobile-databrain'
              ? tableParams?.platforms
              : ['unified'],
          granularity: tableParams?.date_type,
          file_name: businessType,
        };
        if (businessType === 'mobile-demographics') {
          // 根据下载弹窗中用户选择的时间类型决定 granularity
          const downloadTimeType = formModel?._downloadTimeType || tableParams?.granularity || 'lifetime';
          const downloadGranularity =
            downloadTimeType === 'quarter' ? 'quarterly'
            : downloadTimeType === 'month' ? 'monthly'
            : 'lifetime';

          // Basic information 选中项映射到 ext_info
          const extInfoMapping: Record<string, string> = {
            company_show: 'company',
            genre_show: 'genre',
            release_date_show: 'release_time',
            game_engine_show: 'game_engine',
          };
          const ext_info = Object.entries(extInfoMapping)
            .filter(([key]) => formModel?.[key])
            .map(([, val]) => val);

          params = {
            ...params,
            edition_method: 'aggregated',
            start_date: params.dateRange?.[0] || params.start_date,
            end_date: params.dateRange?.[1] || params.end_date,
            file_name: 'Demographics',
            metrics: params.download_metrics || [],
            region_method: 'aggregated',
            granularity: downloadGranularity,
            // download_markets: params.download_markets || [],
            markets: params.download_markets || [],
            page_size: params.select_top || params.page_size,
            ext_info,
            // sensor 下载时 platforms 使用下载弹窗中用户选择的 Platform Settings，不需要 platform 字段
            platforms: formModel?.platforms || ['appstore', 'googleplay'],
          };
          delete params.platform;
          // 清理内部辅助字段
          delete params._downloadTimeType;
        }
        handleDownloadDateTypes(params, {
          downloadDateMethodKey: 'downlaod_date_method',
          downloadDateTypesKey: 'download_date_type',
          dateTypeKey: 'date_type',
        });
        params = tranFormSenorTowerTagParam(params);

        // 这四个榜单在筛选器勾选游戏后，需要对filter_ids用接口查询返回的数据进行重排序，确保下载的游戏顺序跟页面顺序一致
        if (typeof getSortedGameIds === 'function') {
          if (params?.data_method !== 'checkedLines') {
            let filterIds = params?.filter_ids || [];
            if (Array.isArray(filterIds) && filterIds.length > 0) {
              setLoading(true);
              filterIds = await getSortedGameIds?.(filterIds);
              params = {
                ...params,
                filter_ids: filterIds || [],
              };
              setLoading(false);
            }
          }
        }

        break;
      case 'mobile-upcoming':
      case 'mobile-newRelease':
        params = tranFormSenorTowerTagParam(params);
        break;
      case 'mobile-details-store-rank': {
        params = {
          ...params,
          date_method: params?.downlaod_date_method,
        };
        delete params.default_source_type;
        delete params.downlaod_date_method;
        delete params.select_top;
        break;
      }
      case 'mobile-details-store-rank-trend': {
        params = {
          ...params,
          date_method: params?.downlaod_date_method,
        };
        delete params.downlaod_date_method;
        delete params.select_top;
        break;
      }
      case 'alinea-analytics-calibration-pc-console-topCharts': {
        params = {
          ...params,
          source_metrics: getAlineaCalibrationSourceMetrics(formModel?.download_metrics || params?.source_metrics?.alinea_calibration || []),
          company_show: formModel?.company_show ? 1 : 0,
          genre_show: formModel?.genre_show ? 1 : 0,
          release_date_show: formModel?.release_date_show ? 1 : 0,
          file_format: Number(formModel?.file_format),
        };
        delete params.download_metrics;
        delete params.metrics;
        delete params.data_method;
        delete params.data_amount;
        break;
      }
      case 'pc-DigitalRevenue':
      case 'pc-PhysicalRevenue':
      case 'pc-MAU':
      case 'pc-SteamSales':
      case 'pc-LifeTimePlayers':
      case 'pc-MetricsTable':
      case 'console-MetricsTable':
      case 'combine-PCConsoleMetricsTable':
      case 'combine-PCConsoleMetricsTable-studio':
      case 'pc-console-topCharts':
      case 'databrain-calibration-pc-console-topCharts':
      case 'console-DigitalRevenue':
      case 'console-PhysicalRevenue':
      case 'console-MAU':
      case 'console-LifeTimePlayers':
      case 'pc-PCU': {
        params = {
          ...params,
          download_date_type: DATE_TYPE_VALUES.filter((item) =>
            (tableParams?.date_type ? [tableParams.date_type] : [])?.includes(
              item,
            ),
          ),
          company_show: formModel.company_show ? 1 : 0,
          publisher_class_show: formModel?.publisher_class_show ? 1 : 0,
          genre_show: formModel.genre_show ? 1 : 0,
          release_date_show: formModel.release_date_show ? 1 : 0,
          region_show:
            formModel.region_method === 'region'
              ? 0
              : formModel.region_show
                ? 1
                : 0,
          steam_id_show: formModel.steam_id_show ? 1 : 0,
          game_engine_show: formModel.game_engine_show ? 1 : 0,
          platform_show: formModel.platform_show ? 1 : 0,
          ratio_show: formModel.ratio_show ? 1 : 0,
          select_top:
            formModel.data_method === 'selectTop'
              ? formModel.data_amount
              : Number(total),
          file_format: Number(formModel.file_format),
          data_sources: [],
          edition_method: 'aggregated',
          entity_type: tableParams?.entity_type ? tableParams.entity_type : '',
          file_name: tableParams?.pageId,
          genre_source: tableParams.genre_source,
          iegg_genre_req: tableParams.genre_source === 'iegg' ? tableParams.iegg_genre_req : [],
          // 优先使用页面通过 tableParams.order_metrics 传入的列顺序（与表格/下载弹窗指标下拉顺序一致），
          order_metrics: tableParams?.order_metrics?.length
            ? tableParams.order_metrics
            : OrderMetricsMap[tableParams.entity_type + tableParams?.pageId] || [],
          // segment: tableParams?.segment?.toLowerCase(),
          // 这里segment入参跟榜单保持一致 不特殊转小写
          segment: tableParams?.segment,
          device: tableParams.device || [],
          download_devices: formModel.download_devices,
          download_segments: formModel.download_segments,
          // gameCode: [],
          source_metrics: isMetricsTable
            ? getSource_metrics(formModel, businessType)
            : getDataSourceMetrics(
              OrderMetricsMap[tableParams.entity_type + tableParams?.pageId],
              formModel.metrics,
            ),
        };
        if (businessType === 'pc-SteamSales') {
          // 分离 Alinea / Gamalytic / VGI 指标
          const alineaMetrics: string[] = [];
          const gamalyticMetrics: string[] = [];
          const vgiMetrics: string[] = [];

          if (Array.isArray(formModel.metrics)) {
            formModel.metrics.forEach((m: any) => {
              if (typeof m === 'string') {
                if (m.startsWith('alinea__')) {
                  alineaMetrics.push(m);
                } else if (m.startsWith('gamalytic__')) {
                  gamalyticMetrics.push(m);
                } else {
                  vgiMetrics.push(m);
                }
              }
            });
          }

          // 构建 source_metrics
          const sourceMetrics: any = {};
          if (alineaMetrics.length > 0) {
            sourceMetrics.alinea = alineaMetrics;
          }
          if (gamalyticMetrics.length > 0) {
            sourceMetrics.gamalytic = gamalyticMetrics;
          }
          if (vgiMetrics.length > 0) {
            sourceMetrics.vginsights = vgiMetrics;
          }

          // order_metric 和 order_source 根据实际选择的指标类型决定
          const orderMetric = params?.order_metric || 'est_revenue';
          const orderSource = typeof orderMetric === 'string' && orderMetric.startsWith('alinea__')
            ? 'alinea'
            : typeof orderMetric === 'string' && orderMetric.startsWith('gamalytic__')
              ? 'gamalytic'
              : 'vginsights';

          // 格式化日期为 YYYY-MM-DD
          const formatDate = (date: any) => {
            if (!date) return '';
            const m = moment(date);
            return m.isValid() ? m.format('YYYY-MM-DD') : date;
          };

          params = {
            ...params,
            region_type: params?.region_type || params?.regionType,
            start_date: formatDate(params?.start_date || params?.startDate),
            end_date: formatDate(params?.end_date || params?.endDate),
            start_release_time:
              params?.start_release_time || params?.startReleaseTime,
            end_release_time:
              params?.end_release_time || params?.endReleaseTime,
            order: params?.order || params?.sortRule,
            order_metric: orderMetric,
            order_source: orderSource,
            ratio_type: params?.ratio_type,
            page_size: params?.page_size || params?.pageSize,
            search_by_name: params?.search_by_name || params?.searchGameName,
            unified_ids: params?.unified_ids || params?.selectedAppid,
            data_method: '',
            date_type:
              params?.date_type === 'day'
                ? 'daily'
                : params?.date_type?.endsWith('ly')
                  ? `${params?.date_type}`
                  : `${params?.date_type}ly`,
            download_devices: [],
            download_segments: [],
            region_method: 'aggregated',
            segment: 'All',
            source_metrics: sourceMetrics,
          };
        }

        if (businessType === 'console-DigitalRevenue') {
          params = {
            ...params,
            source_download_device: {
              mscience: params.download_devices || [],
            },
          };
        }
        if (businessType === 'console-PhysicalRevenue') {
          params = {
            ...params,
            source_download_device: {
              npd: params.download_devices || [],
            },
          };
        }
        if (
          businessType === 'console-MAU' ||
          businessType === 'console-LifeTimePlayers'
        ) {
          params = {
            ...params,
            source_download_device: {
              newzoo: params.download_devices || [],
            },
          };
        }
        if (isMetricsTable) {
          delete params.metrics;
        }
        if (
          (businessType === 'combine-PCConsoleMetricsTable' ||
            businessType === 'pc-console-topCharts' ||
            businessType === 'databrain-calibration-pc-console-topCharts') &&
          !isStudio
        ) {
          const {
            order_source: orderSource,
            order_metric: orderMetric,
            download_metrics,
            source,
            segment,
            device,
          } = params || {};
          const orderSourceTmp = getServerDataSourceOfCombineMetricsTable(
            orderSource,
            orderMetric,
          );
          const cascaderMetricsMapMap = {
            'combine-PCConsoleMetricsTable': pcConsoleCascaderMetricsMap,
            'pc-console-topCharts': pcConsoleCascaderMetricsMap,
            'databrain-calibration-pc-console-topCharts':
              pcConsoleDataBrainCascaderMetricsMap,
          };
          const cascaderMetricsMap =
            cascaderMetricsMapMap[businessType] || pcConsoleCascaderMetricsMap;
          const source_metrics = changeMetricSelector(
            download_metrics,
            cascaderMetricsMap,
          );
          const resolvedSourceMetrics =
            Object.keys(source_metrics || {}).length > 0
              ? source_metrics
              : params?.fp?.source_metrics || source_metrics;
          const flatSourceMetrics = Object.values(
            resolvedSourceMetrics || {},
          ).reduce<string[]>(
            (acc, metrics) =>
              acc.concat(Array.isArray(metrics) ? metrics : []),
            [],
          );
          const normalizedDownloadMetrics = (download_metrics || []).filter(
            (selectorValue: string) =>
              flatSourceMetrics.includes(
                resolvePcConsoleSelectorMetricKey(
                  selectorValue,
                  cascaderMetricsMap,
                ),
              ),
          );
          const defaultMetacritic = params?.meta_score_show
            ? {
              metacritic: ['meta_score'],
            }
            : {};
          const steamTag = params?.steam_tag_show ? 1 : 0;
          const gameMode = params?.game_mode_show ? 1 : 0;
          const metricsForOrder = normalizedDownloadMetrics.length
            ? normalizedDownloadMetrics
            : download_metrics;
          const orderMetricsForDownload =
            buildOrderMetricsFromSelectorValues(
              metricsForOrder,
              resolvedSourceMetrics,
              cascaderMetricsMap,
            );
          params = {
            ...params,
            order_source: orderSourceTmp,
            download_segments: [],
            segment_method: 'aggregated',
            source_metrics: { ...resolvedSourceMetrics, ...defaultMetacritic },
            source_download_segment: commonFilterSegment(source, segment),
            source_download_device: commonFilterDevice(device),
            topchart_name: 'pc&console',
            steam_tag_show: steamTag,
            game_mode_show: gameMode,
            order_metrics: orderMetricsForDownload.length
              ? orderMetricsForDownload
              : params.order_metrics,
            // 与 source_metrics 对齐后的列顺序，供 Excel 列头与表格列一致
            download_metrics: normalizedDownloadMetrics.length
              ? normalizedDownloadMetrics
              : download_metrics,
          };
        }
        if (isStudio) {
          const { order_source: orderSource, order_metric: orderMetric } =
            params || {};
          const orderSourceTmp = getServerDataSourceOfCombineMetricsTable(
            orderSource,
            orderMetric,
          );
          params = {
            ...params,
            order_source: orderSourceTmp,
            download_segments: [],
          };
        }
        delete params.genre_tab;
        delete params.download_markets;
        delete params.dateRange;
        delete params.platforms;
        delete params.firstPageTopList;
        // 将steamfollower指标转到vgi里
        params = {
          ...params,
          source_metrics: transformData(params?.source_metrics),
        };

        break;
      }
      case 'pc-newRelease':
      case 'pc-upcoming': {
        params = {
          ...params,
          steam_id_show: formModel.steam_id_show ? 1 : 0,
        };
        break;
      }
      case 'companies-downloads': {
        params = {
          ...params,
          download_metrics: ['company_download'],
          order_metric: 'download',
        };
        break;
      }
      case 'companies-mentions': {
        params = {
          ...params,
          download_metrics: ['company_mention'],
        };
        break;
      }
      case 'pc-stats-countries':
      case 'combine-stats-countries':
      case 'combine-detail-allmetrics':
      case 'combine-detail-consoledata':
      case 'combine-detail-steamdata':
      case 'combine-detail-kpitends':
      case 'combine-stats-countries-compare':
      case 'combine-stats-countries-pcu':
      case 'combine-stats-countries-japan-sales':
      case 'combine-stats-countries-ampere':
      case 'pc-stats-countries-pcu':
      case 'console-stats-countries':
      case 'console-stats-countries-japan-sales': {
        const timeType = params.period || params.date_type || '';
        const normalizeCombineDetailMetricItem = (
          item: any,
        ): string[] | null => {
          if (Array.isArray(item) && item.length >= 2) {
            return [String(item[0]), String(item[1])];
          }
          if (typeof item === 'string' && item.includes('###')) {
            const [dataSource, metric] = item.split('###');
            if (dataSource && metric) return [dataSource, metric];
          }
          return null;
        };
        let newMetricsArray = params?.metrics?.map((item: any) => {
          const normalized = normalizeCombineDetailMetricItem(item);
          if (!normalized) return item;
          let [dataSource, metric] = normalized;
          if (
            dataSource === 'steam' &&
            (metric === 'steamfollowers' || metric === 'steamreviews')
          ) {
            return ['vginsights', metric];
          }
          if (
            dataSource === 'steam' &&
            typeof metric === 'string' &&
            metric.startsWith('source_steam__')
          ) {
            return ['source_steam', metric];
          }
          if (typeof metric === 'string' && metric.startsWith('alinea__')) {
            return ['alinea', metric];
          }
          if (typeof metric === 'string' && metric.startsWith('gamalytic__')) {
            return ['gamalytic', metric];
          }
          return [dataSource, metric];
        });

        const gsdSegmentsValues =
          gsdSegments?.map((gsdSegment) => gsdSegment?.value) || [];
        params = {
          ...PcConsoleNewParams,
          ...params,
          steam_id_show: formModel.steam_id_show ? 1 : 0,
          steam_tag_show: formModel.steam_tag_show ? 1 : 0,
          game_mode_show: formModel.game_mode_show ? 1 : 0,
          metrics: newMetricsArray,
          date_type: toDateTypeLy[timeType],
          download_date_type: [toDateTypeLy[timeType]],
          download_segments: [
            'Full Game',
            'DLC: All Other',
            'DLC: Expansion',
            'DLC: Content Pre-Purchase Pass',
            'DLC: Unlockable Content Pass',
            'MTX',
            'Subscription',
            ...gsdSegmentsValues,
          ],
          download_devices: [],
          edition_method: 'aggregated',
          source_metrics: transformData(
            getSource_metrics(
              { ...params, metrics: newMetricsArray },
              businessType,
            ),
          ),
          order_metrics: [
            'combine-detail-allmetrics',
            'combine-detail-consoledata',
            'combine-detail-steamdata',
          ].includes(
            businessType,
          )
            ? tableParams?.order_metrics || []
            : tableParams?.order_metrics?.length
              ? tableParams.order_metrics
              : ORDER_METRICS_MAP_DETAIL[entityType] || [],
          select_top: formModel.data_method === 'selectTop' ? formModel.data_amount : Number(total),
          // hasJapanSales: hasJapanSales
        };

        if (
          [
            'console-stats-countries',
            'console-stats-countries-japan-sales',
          ].includes(businessType)
        ) {
          params = {
            ...params,
            source_download_device: {
              [GSD_SOURCE_KEY]: disabledGsd ? [] : params?.download_devices_gsd,
              npd: disabledNpd ? [] : params.download_devices_npd,
              mscience: disabledMscience
                ? []
                : params.download_devices_mscience,
              famitsu: disabledFamitsu ? [] : params.download_devices_famitsu,
            },
            hasJapanSales: params.currentMetric == 'japanSales',
            platform: ['facebook', 'ytg', 'twitch'],
          };
        }

        if (
          [
            'combine-stats-countries',
            'combine-detail-allmetrics',
            'combine-detail-consoledata',
            'combine-detail-steamdata',
            'combine-detail-kpitends',
            'combine-stats-countries-compare',
            'combine-stats-countries-pcu',
            'combine-stats-countries-japan-sales',
            'combine-stats-countries-ampere',
          ].includes(businessType)
        ) {
          params.metrics = params.metrics?.map((item: any) => {
            if (typeof item === 'string') {
              return item?.split('###');
            }
            return item;
          });
          const finalSourceMetrics = transformData(
            getSource_metrics(params, businessType),
          );
          const orderMetricsFromModal = buildOrderMetricsFromDetailSelectorValues(
            toDetailMetricSelectorValues(formModel?.metrics || params?.metrics),
          );
          const orderMetricsFromPage = buildOrderMetricsFromPageMetricValues(
            tableParams?.metrics,
            finalSourceMetrics,
          );
          const baseOrderMetrics = tableParams?.order_metrics?.length
            ? tableParams.order_metrics
            : orderMetricsFromModal.length
              ? orderMetricsFromModal
              : orderMetricsFromPage;
          params = {
            ...params,
            order_source: params?.source || params?.order_source,
            order_metric: params?.sort_field || params?.order_metric,
            // source_download_device: convertDevicesOfCascaderDevices(
            //   params.downloadDevices,
            // ),
            hasJapanSales: params.currentMetric === 'japanSales',
            platform: ['facebook', 'ytg', 'twitch'],
            source_metrics: finalSourceMetrics,
            order_metrics: getOrderedMetricEntriesFromParams({
              source_metrics: finalSourceMetrics,
              order_metrics: baseOrderMetrics,
            }),
            source_download_segment: commonFilterSegment(
              params?.currentMetric,
              params?.segment,
            ),
            source_download_device: commonFilterDevice(
              params?.device,
              [
                'combine-stats-countries',
                'combine-stats-countries-ampere',
              ].includes(businessType),
            ),
            topchart_name: 'pc&console stats',
          };
          delete params.downloadDevices;
        }

        if (params.currentMetric === 'japanSales') {
          params = {
            ...params,
            hasJapanSales: true,
          };
          delete params.data_sources;
          delete params.metrics;
        }

        delete params.download_devices_famitsu;
        delete params.download_devices_mscience;
        delete params.download_devices_npd;
        break;
      }
      case 'companies-detail': {
        params = {
          ...params,
          source_download_device: {
            npd: disabledNpd ? [] : params.download_devices_npd,
            mscience: disabledMscience ? [] : params.download_devices_mscience,
            famitsu: disabledFamitsu ? [] : params.download_devices_famitsu,
          },
          hasJapanSales: params.currentMetric === 'japanSales',
          platform: ['facebook', 'ytg', 'twitch'],
        };
      }
      case 'companies-detail': {
        params = {
          ...params,
          download_metrics: getCompanyDetailMetrics(params.metrics),
          date_method: 'aggregated',
          current_tab: segpaVa ? segpaVa : '',
          downlaod_date_method: formModel.downlaod_date_method,
          region_method: formModel.region_method,
          ratio_show: formModel.ratio_show ? 1 : 0,
          file_format: Number(formModel.file_format),
          select_top:
            formModel.data_method === 'selectAll'
              ? 9999999
              : formModel.data_amount,
          download_segments: formModel.download_segments,
          metrics: tableParams.metrics,
          file_name: tableParams.gameName,
        };

        delete params.download_detail_metrics;
        delete params.gameName;
        delete params.data_amount;
        delete params.data_method;
        break;
      }
      case 'marketProfile-stats': {
        params = {
          ...params,
          ratio_show: formModel?.ratio_show ? 1 : 0,
          file_format: Number(formModel.file_format),
          // 新风格全局排查文件名规范
          new_style_donwload_file_name: getDownloadFileName(
            'marketProfile-stats',
            newStyleFileName || '',
            entityType,
          ),
          select_top:
            formModel.data_method === 'selectAll'
              ? 9999999
              : formModel.data_amount,
        };
        break;
      }
      case 'following-currentgame-mobile': {
        const hasRetentionMetric = hasFollowingRetentionForDownload(
          tableParams?.metrics,
          tableParams?.source_metric,
        );
        params = {
          // ...tableParams,
          source_metric: tableParams?.source_metric,
          order_metric: tableParams?.order_metric,
          order_source: tableParams?.order_source,
          group_name: tableParams.group_name,
          order: tableParams.order,
          data_sources: ['appannie', 'sensortower'],
          date_method: params?.downlaod_date_method,
          date_type: params.date_type,
          end_date: params.end_date,
          file_format: params.file_format,
          platform: ['facebook', 'ytg', 'twitch'],
          is_following: params.is_following,
          filter: tableParams?.filter,
          region_method: params.region_method,
          start_date: params.start_date,
          // metric: formModel.metrics,
          // unified_ids: getUnifiedIds(params),
          edition_method: 'aggregated', // 固定，此字段follow下载弹框无该选项，只为与mobile详情页下载的接口参数保持一致
          entity_type: entityType,
          date_type_list: hasRetentionMetric
            ? ['monthly']
            : formModel?.downlaod_date_method === 'aggregated'
              ? [params?.date_type]
              : formModel?.download_date_type,
          region_type: 'market',
          regions: params?.marketsValus ? params?.marketsValus : ['global'],
          new_style_donwload_file_name: params?.new_style_donwload_file_name,
          select_top:
            formModel.data_method === 'selectAll'
              ? total
              : formModel.data_amount,
          region_show: formModel?.region_show ? 1 : 0,
          genre_show: formModel?.genre_show ? 1 : 0,
          company_show: formModel?.company_show ? 1 : 0,
          release_date_show: formModel?.release_date_show ? 1 : 0,
          genre_source:
            tableParams.genre_source && tableParams.genre_source == 'iegg'
              ? tableParams.genre_source
              : 'annie',
          ...(hasRetentionMetric
            ? {
                download_metrics: formModel?.download_metrics?.length
                  ? formModel.download_metrics
                  : [...FOLLOWING_RETENTION_DN_METRICS],
              }
            : {}),
        };
        delete params?.revenue_scope;
        delete params?.adjusted_revenue;
        params = appendAdjustedRevenueFilter(params, tableParams?.revenue_scope);
        break;
      }
      case 'following-currentgame': {
        params = {
          // ...tableParams,
          source_metric: tableParams?.source_metric,
          order_metric: tableParams?.order_metric,
          order_source: tableParams?.order_source,
          metrics: tableParams?.metrics,
          // follow_id: getUnifiedIds(params),
          search_id: '',
          region_type: 'market',
          regions: params?.marketsValus ? params?.marketsValus : ['global'],
          start_date: params.start_date,
          end_date: params.end_date,
          // metrics: tableParams.metrics,
          order_field: tableParams.order_field,
          order: tableParams.order,
          group_name: tableParams.group_name,
          entity_type: entityType,
          is_following: params.is_following,
          date_type: params.date_type,
          download_date_type: [tableParams.date_type],
          file_format: params.file_format,
          order_metrics: tableParams?.order_metrics?.length
            ? tableParams.order_metrics
            : FOLLOWING_CURRENTGAME_METRICS,
          data_method: formModel.time_method,
          select_top:
            formModel.data_method === 'selectAll'
              ? total
              : formModel.data_amount,
          new_style_donwload_file_name: params?.new_style_donwload_file_name,
        };
        if (entityType === 'console') {
          params = {
            ...params,
            device: tableParams?.device,
          };
        }
        if (tableParams.genre_source && tableParams.genre_source === 'iegg') {
          params = {
            ...params,
            genre_source: tableParams.genre_source,
            iegg_genre_req: tableParams.iegg_genre_req,
          };
        } else {
          params = {
            ...params,
            genre: tableParams.genre,
            sub_genre: tableParams.sub_genre,
          };
        }
        break;
      }
      case 'following-newgame': {
        params = {
          ...tableParams,
          // follow_id: getUnifiedIds(params),
          search_id: '',
          trace_id: [], // 啥用
          region_type: params.region_type,
          regions: params.regions,
          start_date: params.start_date,
          end_date: params.end_date,
          metrics: ['potential'],
          order_field: 'potential',
          order: 'desc',
          group_name: '',
          entity_type: entityType,
          is_following: params.is_following,
          file_format: params.file_format,
          date_type: params.date_type,
          data_method: formModel.time_method,
          select_top:
            formModel.data_method === 'selectAll' ? 0 : formModel.data_amount,
          new_style_donwload_file_name: params?.new_style_donwload_file_name,
        };
        break;
      }
      case 'following-newcompany': {
        params = {
          ...tableParams,
          // follow_id: getUnifiedIds(params),
          search_id: '',
          trace_id: [],
          region_type: params.region_type,
          regions: params.regions,
          start_date: params.start_date,
          end_date: params.end_date,
          metrics: ['revenue', 'download'],
          order_field: 'revenue',
          order: 'desc',
          entity_type: entityType,
          is_following: params.is_following,
          file_format: params.file_format,
          data_method: formModel.time_method,
          select_top:
            formModel.data_method === 'selectAll' ? 0 : formModel.data_amount,
          downlaod_date_method: formModel.downlaod_date_method,
          page: 1,
          page_size: 20,
          date_type: params.date_type,
          new_style_donwload_file_name: params?.new_style_donwload_file_name,
        };
        break;
      }

      case 'companies-revenue': {
        params = tranFormRevenueRangeParams(params);
        break;
      }

      case 'compare-mobile': {
        delete params.default_data_sources;
        break;
      }

      case 'genre-profile': {
        params = {
          ...params,
          entity_type: params?.game_platform,
          granularity: 'monthly',
          regionType: 'market',
          genre: params?.genre || [],
          genreSegment: 'all',
          genre_source:
            params?.game_platform === 'mobile' ? params?.genre_source : 'iegg',
          is_download_all: params?.select_top === total,
          iegg_genre_req: params?.iegg_genre_req || [],
          select_top:
            formModel.data_method === 'selectAll'
              ? 100000
              : formModel.data_amount,
          genre_tab: tableParams?.genreType,
          // 新风格全局排查文件名规范
          new_style_donwload_file_name: getDownloadFileName(
            'genre-profile',
            newStyleFileName || '',
            params?.game_platform,
          ),
        };
        delete params?.genreType;
        delete params?.game_platform;
        break;
      }

      case 'genre-profile-detail': {
        params = {
          ...params,
          entity_type: params?.game_platform,
          // metrics: ['digital_revenue', 'physical_revenue', 'mau'],
          select_top:
            formModel.data_method === 'selectAll'
              ? 100000
              : formModel.data_amount,
          regionType: 'market',
          keyword: '',
          select_code: [],
        };

        delete params?.game_platform;
        delete params?.data_category;
        delete params?.market_type;
        break;
      }

      case 'pc-details-store-rank': {
        params = {
          ...params,
          steam_id_show: formModel.steam_id_show ? 1 : 0,
        };
        break;
      }
      case 'minigame-details-store-rank': {
        params = {
          ...params,
          company_show: formModel?.company_show ? 1 : 0,
          genre_show: formModel?.genre_show ? 1 : 0,
          start_date: formModel.dateRange?.[0] || params.start_date,
          end_date: formModel.dateRange?.[1] || params.end_date,
        };
        break;
      }
      case 'pc-console-detail-store-rank': {
        const hasPCSource = params?.source_type?.some((item) =>
          ['steam', 'epic']?.includes(item),
        );
        const hasConsoleSource = params?.source_type?.some((item) =>
          ['play_station', 'xbox', 'nintendo']?.includes(item),
        );

        const pcRegion = hasPCSource ? ['global'] : [];

        const separateRegion = [
          ...(hasPCSource ? tableParams?.steam_market : []),
          ...(hasConsoleSource ? tableParams?.playstation_market : []),
        ];
        params = {
          ...params,
          steam_id_show: formModel.steam_id_show ? 1 : 0,
          edition_method: 'aggregated',
          entity_type: 'combine',
          date_type: params?.granularity,
          regions:
            params?.region_method === 'market'
              ? uniq([...separateRegion, ...pcRegion])
              : uniq([...params.markets, ...pcRegion]),
          new_style_donwload_file_name: params?.name,
        };
        delete params?.name;
        delete params.markets;
        delete params.hasConsole;
        delete params.hasPc;
        delete params?.platform;
        delete params?.top;
        delete params.granularity;
        delete params.playstation_market;
        delete params.steam_market;
        delete params.storeRankPlatform;
        break;
      }

      case 'mobile-benchmark-kpi_data': {
        const metricsName = params?.metrics?.join('+');
        const systemName =
          params?.systems === 'Both'
            ? 'AppStore+GooglePlay'
            : params?.systems === 'ios'
              ? 'AppStore'
              : 'GooglePlay';
        const timeName = params?.time_period === '1m~12m' ? 'M1-M12' : 'Y1-Y5';
        const kpiDataFileName = `mobile_benchmark_${params?.genre_type || ''
          }_kpi_${metricsName}_${systemName}_${timeName}`;
        params = {
          ...params,
          systems:
            params?.systems === 'Both'
              ? ['Android', 'ios']
              : params?.systems
                ? [params.systems]
                : undefined,
          file_name: kpiDataFileName,
        };
        break;
      }

      case 'mobile-benchmark-player_activity': {
        params = {
          ...params,
          systems:
            params?.systems === 'Both'
              ? ['Android', 'ios']
              : params?.systems
                ? [params.systems]
                : undefined,
          file_name: `mobile_benchmark_${params?.genre_type || ''
            }_retention+arpdau+ltv`,
        };
        break;
      }

      case 'mobile-benchmark-basic_info': {
        params = {
          ...params,
          file_name: `mobile_benchmark_${params?.genre_type || ''
            }_social_channels_basic_info`,
        };
        break;
      }

      case 'mobile-benchmark-social_channels': {
        params = {
          ...params,
          file_name: `mobile_benchmark_${params?.genre_type || ''
            }_social_channels`,
        };
        break;
      }

      // case 'combine-PCConsoleMetricsTable-studio': {
      //   params = {
      //     ...params,
      //     steam_id_show: formModel.steam_id_show ? 1 : 0,
      //   };
      //   break;
      // }

      case 'overlap-mobile-games': {
        params = {
          ...params,
          download_metrics: params?.metrics || [],
          download_start_date: params?.dateRange[0] || '',
          download_end_date: params?.dateRange[1] || '',
        };
        handleDownloadDateTypes(params, {
          downloadDateMethodKey: 'downlaod_date_method',
          downloadDateTypesKey: 'download_date_type',
          dateTypeKey: 'date_type',
        });
        params = tranFormSenorTowerTagParam(params);
        break;
      }

      case 'streaming-games-top': {
        if (formModel.data_method !== 'checkedLines') {
          params.select_ids = [];
        }
        break;
      }

      default:
        params = {
          ...params,
        };
        break;
    }

    // 游戏榜单topcharts，统一处理宽表联动参数
    if (isGameTopCharts && isNeedCheckedLines) {
      if (formModel?.data_method === 'checkedLines') {
        params = {
          ...params,
          select_ids: getSelectIds(params.select_ids),
        };
      } else if (
        formModel?.data_method === 'selectTop' &&
        formModel?.data_amount <= 100 &&
        (businessType === 'combine-PCConsoleMetricsTable' ||
          businessType === 'pc-console-topCharts' ||
          businessType === 'databrain-calibration-pc-console-topCharts')
      ) {
        // 这里是榜单页下载接口优化逻辑，如果用户选择的是selectTop，并且top数量小于100，则直接使用select_ids参数
        let select_ids = tableParams?.select_ids || [];
        select_ids = tableParams?.firstPageTopList?.filter(
          (item: string, index: number) => index + 1 <= formModel?.data_amount,
        );
        params = {
          ...params,
          select_ids,
        };
      } else {
        delete params.select_ids;
      }
    }

    if (
      isNeedCheckedLines &&
      typeof getCheckedLinesCfg === 'function' &&
      formModel?.data_method === 'checkedLines'
    ) {
      const { key, value } = getCheckedLinesCfg();
      params[key] = value;
    }

    if (
      businessType === 'alinea-analytics-calibration-pc-console-topCharts' &&
      formModel?.data_method !== 'selectTop'
    ) {
      delete params?.select_top;
    }

    if (
      ![
        'following-currentgame-mobile',
        'following-currentgame',
        'following-newgame',
        'following-newcompany',
        'mobile-rpd',
        'marketProfile-combine',
        'casualGenreProfile',
        'marketProfileStatsNew',
        'mobile-store-rank-more',
        'mobile-store-rank-top',
        'console-store-rank-more',
        'console-ps-store-rank-top',
        'console-xbox-store-rank-top',
        'console-nintendo-store-rank-top',
        'pc-steam-store-rank-top',
        'pc-epic-store-rank-top',
        'weixin-store-rank-more',
        'casualCompetitorsKeyGames',
        'casualCompetitorsTopPublishers',
      ].includes(businessType)
    ) {
      delete params?.data_method;
      delete params?.data_amount;
    }
    handleDownloadLog(downloadLogConfigKey);
    aegisLog.reportEvent({
      name: 'dbi-download-configs-settings',
      msg: 'set download configs',
      ext1: JSON.stringify(formModel || {}),
      ext2: JSON.stringify(params || {}),
      // ext3: '',
    });
    // 手动切换是否走前端下载
    if (getUseWebDownloadCur(params)) {
      let downLoadParamsValue = params;
      // 如果有downloadPageFun函数，且用户选择了下载topN，则先获取topN的idList
      if (
        typeof downloadPageFun === 'function' &&
        formModel?.data_method === 'selectTop'
      ) {
        setLoading(true);
        const pageFunParams = await downloadPageFun?.(
          params,
          formModel?.download_metrics,
          formModel?.data_amount,
        );
        downLoadParamsValue = pageFunParams || params;
        setLoading(false);
      }

      let downloadKeyCur = downloadKey;
      // 此处为了应对MarketProfile-stats-mobile详情页面，但选择了pc/console下载做的单独转换key的处理
      if (businessType === 'marketProfile-stats' && formModel?.entity_type !== 'mobile') {
        downloadKeyCur = 'marketProfileStatsNew';
      }

      downloadAction({
        downLoadParams: downLoadParamsValue,
        downloadKey: downloadKeyCur,
        downloadQuery,
      }); /// todo
      setModalVisible(false);
      return;
    }
    openCommonDownloadPage(params);
  };

  const handleFormChange = (data: { [key: string]: any; }) => {
    if (isMobileStatsMetricDownloadScene) {
      const sanitized = sanitizeMobileRetentionStatsDownloadPatch(
        formModel as Record<string, any>,
        data,
      );
      setFormModelState(sanitized);
    } else {
      setFormModelState(data);
    }
    if (businessType === 'overlap-mobile-games' && data?.metrics) {
      const disabled = !data?.metrics?.includes('mau');
      disabled && setFormModelState({ ratio_show: false });
      setDisabledRatio(disabled);
    }
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };
  const isFormValid = useMemo(() => {
    if (!formModel) return false;
    const {
      metrics,
      data_method,
      data_amount,
      genre_types = [],
      // download_markets = [],
      download_segments = [],
    } = formModel;

    // 检测formModel中 是否存在metrics字段，存在则做必选校验（多数情况下载表单 有metrics，就会有metrics的必选校验）
    if (Reflect.has(formModel, 'metrics')) {
      if (!Array.isArray(metrics) || !metrics.length) return false;
    }
    if (data_method === 'selectTop' && data_amount < 1) return false;
    if (isBlur) return false;

    if (businessType === 'genreprofile' && genre_types.length < 1) return false;
    if (businessType === 'genre-profile' && genre_types.length < 1)
      return false;
    if (
      businessType === 'mobile-demographics' &&
      formModel?.download_metrics?.length < 1
    )
      return false;
    if (
      businessType === 'genre-profile-detail' &&
      formModel?.data_category?.length < 1
    )
      return false;
    // if (entityType == 'combine' && formModel?.downloadDevices && formModel?.downloadDevices?.length < 1)
    //   return false;
    // if (businessType === 'demographics' && (!Array.isArray(metrics)) && !metrics.length && !download_markets.length) return false;
    if (
      (businessType === 'pc-DigitalRevenue' ||
        businessType === 'console-DigitalRevenue') &&
      !download_segments.length
    )
      return false;

    if (
      ['streaming-games-top', 'streaming-anchors-more'].includes(businessType)
    ) {
      const { platform, download_metrics: downloadMetrics } = formModel || {};
      if (!Array.isArray(platform) || !platform.length) return false;
      if (!Array.isArray(downloadMetrics) || !downloadMetrics.length)
        return false;
    }

    if (
      isMobileStatsMetricDownloadScene &&
      (!Array.isArray(formModel?.metric) || formModel.metric.length < 1)
    ) {
      return false;
    }

    if (formModel?.data_sources && formModel?.data_sources?.length < 1)
      return false;

    if (
      STORE_RANK_TOP_BUSINESS_TYPES.includes(businessType) &&
      (!Array.isArray(formModel?.sources) || formModel.sources.length < 1)
    ) {
      return false;
    }

    return true;
  }, [
    formModel,
    cascaderDeviceValueList?.current,
    businessType,
    isMobileStatsMetricDownloadScene,
  ]);

  const DATA_AMOUNTS_LIST = useMemo(() => {
    if (isOnlyExportAllData) return EXPORT_ALL_DATA_AMOUNTS;
    if (isAllAndChecked) return DATA_AMOUNTS_ALL_AND_CHECKED;
    return isNeedCheckedLines ? DATA_AMOUNTS_CHECKED : DATA_AMOUNTS;
  }, [isOnlyExportAllData, isAllAndChecked, isNeedCheckedLines]);

  const limitMaxSize = useMemo(() => {
    if (maxSize) return maxSize;

    return total || SELECT_TOP;
  }, [total, maxSize]);

  const changeIcon = (data: any) => {
    try {
      data.forEach((item: any) => {
        if (item.label === 'dbi_label_metrics') {
          item.cascadeOptions?.forEach((keys: any) => {
            if (keys.children) {
              keys.children.forEach((subKeys: any) => {
                subKeys.icon =
                  subKeys.icon === 'sensortower' || subKeys.icon === 'appannie'
                    ? dataSource
                    : subKeys.icon;
              });
            }
          });
          item.options?.forEach((keys: any) => {
            keys.source =
              keys.source === 'sensortower' || keys.source === 'appannie'
                ? dataSource
                : keys.source;
          });
        }
      });
    } catch (error) { }
  };

  // 根据时间粒度改变D1文本
  function replaceLabel({ list, dateType }) {
    const isMonth = dateType === 'monthly';
    const mid = isMonth ? 'monthly_' : '';
    const splitor = 'dbi_metric_';
    const ampereSplitor = 'ampere###';

    const targetList = [
      'ampere_d1',
      'ampere_d7',
      'ampere_d14',
      'ampere_d28',
      'ampere_d60',
      'ampere_rolling_d1',
      'ampere_rolling_d7',
      'ampere_rolling_d14',
      'ampere_rolling_d28',
      'ampere_rolling_d60',
    ];

    const isAmpereOpts = list?.[0]?.cascadeOptions?.find(
      (opt) => opt?.value === 'ampere',
    );

    const isAmpereSubOpts = isAmpereOpts?.children?.map((sub) => {
      const textStrArr = sub?.value?.split(ampereSplitor);
      const realMetricVal = textStrArr?.[textStrArr?.length - 1];
      const strArr = sub?.text?.split(splitor);
      const rawMetricText = strArr?.[textStrArr?.length - 1];
      const hasMonthlyMid = sub?.text?.includes('monthly_');

      if (targetList.includes(realMetricVal) && isMonth && !hasMonthlyMid) {
        const newText = `${splitor}${mid}${rawMetricText}`;
        return {
          ...sub,
          text: newText,
          txtkey: newText,
        };
      }
      if (targetList.includes(realMetricVal) && !isMonth && hasMonthlyMid) {
        const strArrMonth = sub?.text?.split('dbi_metric_monthly_');
        const rawMetricTextMonth = strArrMonth?.[textStrArr?.length - 1];
        const newText = `${splitor}${mid}${rawMetricTextMonth}`;
        return {
          ...sub,
          text: newText,
          txtkey: newText,
        };
      }
      return sub;
    });

    list?.[0]?.cascadeOptions?.forEach((opt) => {
      if (opt?.value === 'ampere' && opt?.children) {
        opt.children = isAmpereSubOpts;
      }
    });

    // console.debug('in replaceLabel', { isAmpereSubOpts, list, });
  }

  /** 可对特殊下载的formList进行修改（不含留存下载联动补丁，避免依赖 formModel 导致重置表单） */
  const formListProcessed = useMemo(() => {
    // 支持动态配置：优先使用 getFormList 函数
    const config = DownLoadConfig?.[businessType];
    let listTmp: any[] = [];

    if (typeof config?.getFormList === 'function') {
      // 调用 getFormList 函数获取动态配置
      listTmp = config.getFormList(tableParams) || [];
    } else {
      // 使用静态 formList 配置
      listTmp = config?.formList || [];
    }

    if (businessType === 'combine-stats-countries-compare') {
      const granularity = tableParams?.granularity || tableParams?.date_type;
      const metricValues = allMetricsOptions
        .filter((item: any) => item.dateEnum.includes(granularity))
        .map((item: any) => item.value);
      listTmp = listTmp.map((item: any) =>
        item.field === 'metrics'
          ? {
            ...item,
            cascadeOptions: item.cascadeOptions.map((source: any) => ({
              ...source,
              children: source.children.filter((metric: any) =>
                metricValues.includes(metric.value.split('###')[1]) ||
                  (source.value === 'famitsu' && granularity === 'weekly'),
              ),
            })).filter((source: any) => source.children.length),
          }
          : item,
      );
    }

    // 替换 label
    replaceLabel({
      list: listTmp,
      dateType: tableParams?.date_type,
    });

    // 切换数据源图标
    changeIcon(listTmp);
    // console.debug('needCondi', {
    //   tableParams,
    //   dateType: tableParams?.date_type,
    //   listTmp,
    //   // _listTmp,
    // });

    const list = updateCascaderMetricOptionsDisabledStateAndDefaultValue(
      listTmp,
      {
        pageId,
        tableParams: {
          ...tableParams,
          date_type: tableParams?.date_type || tableParams?.period,
          isCountriesPage: tableParams?.isCountriesPage ?? isCoutriesPage,
        },
      },
    );
    switch (businessType) {
      case 'pc-console-detail-store-rank':
        // eslint-disable-next-line no-case-declarations
        const sourceIndex = list.findIndex(
          (item) => item?.field === 'source_type',
        );
        if (sourceIndex > -1) {
          const pcSource = [
            { label: 'Steam', value: 'steam' },
            { label: 'Epic', value: 'epic' },
          ];
          const consoleSource = [
            { label: 'Playstation', value: 'play_station' },
            { label: 'Xbox', value: 'xbox' },
            { label: 'Nintendo', value: 'nintendo' },
          ];
          const combineSource = [
            ...(tableParams?.hasPc ? pcSource : []),
            ...(tableParams?.hasConsole ? consoleSource : []),
          ];
          set(list, `${sourceIndex}.options`, combineSource);
          return list;
        }
        return list;
      case 'console-stats-countries':
      case 'console-stats-countries-japan-sales': {
        if (!Array.isArray(list)) return [];
        if (!Array.isArray(gsdDevicesFlatten) || !gsdDevicesFlatten.length)
          return list;
        const gsdDevicesFlattenOptions = gsdDevicesFlatten.map((item) => ({
          value: item?.value,
          label: item?.text,
          disabled: false,
          disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
        }));
        return list.map((item) => {
          const subList = item?.children;
          if (
            item?.type !== 'subForm' ||
            !Array.isArray(subList) ||
            !subList.length
          )
            return { ...item };
          const subListTmp = subList.map((subItem) => {
            if (subItem?.field !== 'download_devices_gsd')
              return { ...subItem };

            // if (subItem?.field !== 'download_devices_gsd')
            //   return { ...subItem, options: gsdDevicesFlattenOptions };
            return { ...subItem, options: gsdDevicesFlattenOptions };
          });
          return { ...item, children: subListTmp };
        });
      }
      case 'combine-stats-countries':
      case 'combine-detail-allmetrics':
      case 'combine-detail-consoledata':
      case 'combine-detail-steamdata':
      case 'combine-detail-kpitends':
      case 'combine-stats-countries-compare':
      case 'combine-stats-countries-pcu':
      case 'combine-stats-countries-japan-sales':
      case 'combine-stats-countries-ampere': {
        // PC&Console 移除 VGI Steam Weighted Price
        deleteVgiWeightPriceOption(list);

        if (!Array.isArray(list)) return [];
        // console.debug('here...before return list');
        if (!Array.isArray(gsdDevicesFlatten) || !gsdDevicesFlatten.length)
          return list;

        return list.map((item) => {
          if (item?.field !== 'downloadDevices') return { ...item };
          const gsdDevicesOptions = gsdDevicesFlatten?.map((subItem) => {
            const itemValue = `${GSD_SOURCE_KEY}###${subItem?.value}`;
            const itemText = subItem?.text;
            return {
              value: itemValue,
              text: itemText,
              textCN: itemText,
            };
          });
          const gsdDeviceSource = {
            value: GSD_SOURCE_KEY,
            text: 'GSD',
            children: gsdDevicesOptions || [],
            icon: GsdIcon,
            bubbleContent: InfoDoc.dbi_info_gsd_metrics_category_disabled_tips,
            bubbleContentCN:
              InfoDocCN.dbi_info_gsd_metrics_category_disabled_tips,
          };
          const gsdDeviceSources = composeDeviceOptionsAndGsdDeviceOptions(
            item?.options,
            gsdDeviceSource,
          );

          return { ...item, options: gsdDeviceSources };
        });
      }
      case 'pc-console-topCharts':
      case 'databrain-calibration-pc-console-topCharts':
      case 'combine-PCConsoleMetricsTable-studio':
      case 'combine-PCConsoleMetricsTable': {
        // 原studio页面的下载与榜单页是同一个组件且同一个config配置，现在拆分开来。
        // 榜单页下载弹窗的Options与页面保持一致，更换了公共组件options格式会不一样，所以直接取页面种的options使其一致
        if (isStudio) return list;
        return list.map((item) => {
          if (item?.field === 'download_metrics') {
            return {
              ...item,
              options: metricSelectorOptions,
            };
          }
          return item;
        });
      }
      case 'marketProfile-combine': {
        return list.map((item) => {
          if (item?.field === 'metric') {
            return {
              ...item,
              options: metricSelectorOptions.map((t: any) => {
                return { ...t, label: t.metricName, source: t.dataSource };
              }),
            };
          }
          return item;
        });
      }
      case 'weixin-store-rank-more': {
        if (MINI_GAME_RANKING_KEY_LIST_DOUYIN.includes(tableParams?.topchart_name)) {
          return list.filter((item) => item?.field !== 'data_sources');
        }
        return list;
      }
      case 'mobile-store-rank-top':
      case 'pc-steam-store-rank-top':
      case 'pc-epic-store-rank-top':
      case 'console-ps-store-rank-top':
      case 'console-xbox-store-rank-top':
      case 'console-nintendo-store-rank-top':
        return injectStoreRankTopRankingOptions(list, tableParams, entityType);
      case 'following-currentgame-mobile': {
        if (
          !hasFollowingRetentionForDownload(
            tableParams?.metrics,
            tableParams?.source_metric,
          )
        ) {
          return list.filter((item) => item?.field !== 'download_metrics');
        }
        return list;
      }
      default:
        return list;
    }
  }, [tableParams, businessType, entityType, gsdDevicesFlatten, segpaVa, isCoutriesPage, pageId]);

  const formList = useMemo(() => {
    if (isMobileStatsMetricDownloadScene) {
      return patchMobileRetentionStatsDownloadFormList(
        formListProcessed,
        formModel as Record<string, any>,
      );
    }
    return formListProcessed;
  }, [
    formListProcessed,
    isMobileStatsMetricDownloadScene,
    formModel?.data_sources,
    formModel?.metric,
  ]);

  const isShowDownloadAmountType =
    useDownloadAmountType &&
    formModel?.data_method === 'selectTop' &&
    !isDisableDataAmount &&
    !isAllAndChecked;

  useEffect(() => {
    // 表单默认值处理 扁平化
    let defaultFormData =
      formListProcessed?.reduce((result, item) => {
        if (!!item?.children?.length) {
          item?.children?.forEach((config) => {
            if (config?.field) {
              if (item?.type === 'checkbox') {
                result = {
                  ...result,
                  ...config?.defaultValue,
                };
              } else {
                result[config?.field] = config?.defaultValue;
              }
            }
          });
        } else {
          if (item?.field) {
            if (item?.type === 'checkbox') {
              result = {
                ...result,
                ...item?.defaultValue,
              };
            } else {
              result[item?.field] = item?.defaultValue;
            }
          }
        }
        return result;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      }, {} as { [key: string]: any; }) || {};

    // tableParams传递下来的默认值处理
    switch (businessType) {
      case 'mobile-activeuser':
      case 'mobile-activeuser-studio':
      case 'mobile-revenue':
      case 'mobile-downloads':
      case 'mobile-rpd':
      case 'mobile-databrain':
        {
          defaultFormData = {
            ...defaultFormData,
            // revenue_setting: tableParams?.metric_filter || {},
            data_sources: tableParams?.data_sources || ['appannie'],
            download_date_type: [tableParams?.date_type] || ['daily'],
          };
        }
        break;
      case 'mobile-retention':
        defaultFormData = {
          ...defaultFormData,
          data_sources: tableParams?.data_sources || ['sensortower'],
        };
        break;
      case 'following-currentgame-mobile': {
        if (
          hasFollowingRetentionForDownload(
            tableParams?.metrics,
            tableParams?.source_metric,
          )
        ) {
          defaultFormData = {
            ...defaultFormData,
            download_metrics: [...FOLLOWING_RETENTION_DN_METRICS],
          };
        }
        break;
      }
      case 'mobile-stats-retentionmonthly':
      case 'mobile-stats-retentionlifetime': {
        const tabDefaults = getMobileStatsRetentionDownloadTabDefaults(
          tableParams?.segment,
        );
        defaultFormData = {
          ...defaultFormData,
          metric: tabDefaults?.metric ?? [],
          data_sources: tabDefaults?.data_sources ?? [],
          date_method:
            tableParams?.segment === 'retention—retention_lifetime'
              ? 'aggregated'
              : defaultFormData?.date_method,
          download_date_type: [
            'retention—retention_lifetime',
            'retention—retention_monthly',
            'retention—retention_monthly_sensortower',
          ].includes(tableParams?.segment)
            ? ['monthly']
            : [tableParams?.date_type],
          region_method: isCoutriesPage ? 'market' : 'aggregated', // countries的时候默认选中'market'
          downlaod_date_method: isCoutriesPage ? 'aggregated' : 'separate', // countries的时候默认选中'aggregated'
        };
        break;
      }
      case 'mobile-stats-countries-rpd':
        defaultFormData = {
          ...defaultFormData,
          metric: getStatsMetric(tableParams?.segment),
          data_sources:
            Array.isArray(tableParams?.data_sources) &&
            tableParams.data_sources.length > 0
              ? tableParams.data_sources
              : ['appannie', 'sensortower'],
          date_method:
            tableParams?.segment === 'retention—retention_lifetime'
              ? 'aggregated'
              : defaultFormData?.date_method,
          download_date_type: [
            'retention—retention_lifetime',
            'retention—retention_monthly',
            'retention—retention_monthly_sensortower',
          ].includes(tableParams?.segment)
            ? ['monthly']
            : [tableParams?.date_type],
          region_method: isCoutriesPage ? 'market' : 'aggregated', // countries的时候默认选中'market'
          downlaod_date_method: isCoutriesPage ? 'aggregated' : 'separate', // countries的时候默认选中'aggregated'
        };
        break;
      case 'mobile-stats-countries':
        defaultFormData = {
          ...defaultFormData,
          metric: getStatsMetric(tableParams?.segment),
          data_sources: [tableParams?.source] || ['appannie'],
          download_date_type: [tableParams?.date_type] || ['monthly'],
          region_method: isCoutriesPage ? 'market' : 'aggregated', // countries的时候默认选中'market'
          downlaod_date_method: isCoutriesPage ? 'aggregated' : 'separate', // countries的时候默认选中'aggregated'
        };
        break;
      case 'mobile-details-store-rank': {
        const initialSourceTypes = (() => {
          const customSourceTypes = tableParams?.default_source_type;
          const defaultSourceTypes = defaultFormData?.source_type;
          return Array.isArray(customSourceTypes) &&
            customSourceTypes.length > 0
            ? customSourceTypes
            : defaultSourceTypes;
        })();
        defaultFormData = {
          ...defaultFormData,
          source_type: initialSourceTypes,
        };
        break;
      }
      case 'marketProfile-combine': {
        defaultFormData = {
          ...defaultFormData,
          metric: metricSelectorOptions?.map((item: any) => item?.value) || [],
        };
        break;
      }
      case 'marketProfile-stats':
        defaultFormData = {
          ...defaultFormData,
          entity_type: entityType,
          download_metrics:
            dataType === 'operation'
              ? ['operation']
              : dataType === 'game' || dataType === 'games'
                ? ['games']
                : dataType === 'genre' || dataType === 'genres'
                  ? ['main_genres', 'sub_genres']
                  : ['companies'],
        };
        break;
      case 'compare-mobile': {
        const initialDataSources = tableParams?.default_data_sources?.length
          ? tableParams?.default_data_sources
          : defaultFormData?.data_sources;
        defaultFormData = {
          ...defaultFormData,
          data_sources: initialDataSources,
        };
        break;
      }
      case 'mobile-benchmark-kpi_data': {
        defaultFormData = {
          ...defaultFormData,
          metrics: tableParams?.metrics || defaultFormData?.metrics,
          sources: tableParams?.sources || defaultFormData?.sources,
        };
        break;
      }
      case 'mobile-benchmark-player_activity': {
        defaultFormData = {
          ...defaultFormData,
          sources: tableParams?.sources || defaultFormData?.sources,
        };
        break;
      }
      case 'mobile-benchmark-social_channels': {
        defaultFormData = {
          ...defaultFormData,
          steam_source:
            tableParams?.steam_source || defaultFormData?.steam_source,
          time_scale: tableParams?.time_scale || defaultFormData?.time_scale,
        };
        break;
      }
      case 'genre-profile': {
        defaultFormData = {
          ...defaultFormData,
          game_platform: entityType || defaultFormData?.game_platform,
          genre_types: [tableParams?.genreType] || defaultFormData?.genreType,
          genre_source: tableParams?.genreSource,
        };
        break;
      }
      case 'genre-profile-detail':
        defaultFormData = {
          ...defaultFormData,
          downlaod_date_method: 'separate',
          download_metrics:
            [tableParams?.data_category] || defaultFormData.data_category,
          game_platform:
            tableParams?.market_type || defaultFormData?.game_platform,
          genre_source: tableParams?.genre_source,
        };
        break;
      case 'alinea-analytics-calibration-pc-console-topCharts': {
        const metrics = tableParams?.source_metrics?.alinea_calibration || [];
        defaultFormData = {
          ...defaultFormData,
          download_metrics: metrics,
        };
        break;
      }
      case 'streaming-games-top':
      case 'streaming-anchors-more': {
        defaultFormData = {
          ...defaultFormData,
          platform:
            tableParams?.platform ||
            tableParams?.platfrom ||
            defaultFormData?.platform,
        };
      }
      case 'pc-console-topCharts':
      case 'databrain-calibration-pc-console-topCharts':
      case 'combine-PCConsoleMetricsTable': {
        if (
          Array.isArray(tableParams?.metrics) &&
          tableParams?.metrics?.length > 0
        ) {
          defaultFormData = {
            ...defaultFormData,
            metrics: tableParams?.metrics,
            download_metrics:
              tableParams?.download_metrics || tableParams?.metrics,
          };
        }
      }
      case 'combine-PCConsoleMetricsTable-studio': {
        if (
          Array.isArray(tableParams?.metrics) &&
          tableParams?.metrics?.length > 0
        ) {
          defaultFormData = {
            ...defaultFormData,
            metrics: tableParams?.metrics,
          };
        }
      }
      case 'pc-console-detail-store-rank': {
        const sourceType = tableParams?.storeRankPlatform
          ? tableParams?.storeRankPlatform === 'playstation'
            ? 'play_station'
            : tableParams?.storeRankPlatform
          : defaultFormData?.source_type;
        defaultFormData = {
          ...defaultFormData,
          source_type: [sourceType],
        };
        break;
      }
      case 'combine-stats-countries':
      case 'combine-detail-allmetrics':
      case 'combine-detail-consoledata':
      case 'combine-detail-steamdata':
      case 'combine-detail-kpitends':
      case 'combine-stats-countries-compare':
      case 'combine-stats-countries-pcu':
      case 'combine-stats-countries-japan-sales':
      case 'combine-stats-countries-ampere': {
        const downloadDevicesStatic = defaultFormData?.downloadDevices || [];
        const downloadDevicesDynamic =
          gsdDevicesFlatten?.map((item) =>
            generateDataSourceMetricKey(GSD_SOURCE_KEY, item?.value, '###'),
          ) || [];
        const downloadDevices = Array.from(
          new Set([...downloadDevicesStatic, ...downloadDevicesDynamic]),
        );

        // allMetric详情页的metrics选项的key跟下载弹窗的key不一致，需要处理后才能正确回显到下载弹窗
        const metrics =
          businessType === 'combine-stats-countries-compare' ||
          ['allMetrics', 'consoleData'].includes(tableParams?.currentMetric)
            ? getAllMetricsDeatilDefaultMetrics(
              tableParams?.source_metrics,
              formList,
              tableParams?.metrics,
            )
            : getCombineDetailDefaultMetrics(
              tableParams?.source,
              tableParams?.subSegment,
              formList,
            );

        defaultFormData = {
          ...defaultFormData,
          region_method: tabType === 'countries' ? 'market' : 'aggregated',
          downlaod_date_method: tabType === 'countries' ? 'aggregated' : 'separate', // countries的时候默认选中'aggregated'
          metrics,
          downloadDevices: getCascaderDeviceValue(
            downloadDevices,
            tableParams,
            pageId,
            '',
          ),
        };
        break;
      }
      case 'mobile-demographics': {
        const markets = tableParams?.markets;
        const source = tableParams?.source || 'sensortower';
        const isSensorTower = source === 'sensortower';
        const granularity = tableParams?.granularity || 'lifetime';

        if (isSensorTower) {
          const timeType = granularity === 'quarterly' ? 'quarter' : 'lifetime';
          // lifetime 时用页面记录的初始 lifetime 时间（不受 quarter 切换影响）
          // quarter 时优先用 _quarterLatestDate（后端返回的最新季度日期），兜底用 start_date
          const quarterDate = tableParams?._quarterLatestDate || '';
          const startDate = timeType === 'lifetime'
            ? (tableParams?._lifetimeStartDate || tableParams?.start_date || defaultFormData?.start_date || '')
            : (quarterDate || tableParams?.start_date || defaultFormData?.start_date || '');
          const endDate = timeType === 'lifetime'
            ? (tableParams?._lifetimeEndDate || tableParams?.end_date || defaultFormData?.end_date || '')
            : (quarterDate || tableParams?.end_date || defaultFormData?.end_date || '');
          defaultFormData = {
            ...defaultFormData,
            download_markets: markets?.length ? markets : defaultFormData?.download_markets || ['global'],
            dateRange: [startDate, endDate],
            start_date: startDate,
            end_date: endDate,
            _downloadTimeType: timeType,
            // 传递 lifetime 固定日期供弹窗内切换使用
            _lifetimeStartDate: tableParams?._lifetimeStartDate || '',
            _lifetimeEndDate: tableParams?._lifetimeEndDate || '',
            _quarterLatestDate: quarterDate,
          };
        } else {
          // appannie: 用月粒度
          const date = tableParams?.date;
          const dateM = date ? moment(date) : null;
          const isDateMValid = !!dateM?.isValid();
          const startDate = isDateMValid
            ? dateM?.startOf('month').format('YYYY-MM-DD')
            : (tableParams?.start_date || defaultFormData?.start_date);
          const endDate = isDateMValid
            ? dateM?.startOf('month').format('YYYY-MM-DD')
            : (tableParams?.end_date || defaultFormData?.end_date);
          defaultFormData = {
            ...defaultFormData,
            download_markets: markets?.length ? markets : defaultFormData?.download_markets,
            dateRange: [startDate, endDate],
            start_date: startDate,
            end_date: endDate,
            _downloadTimeType: 'month',
          };
        }
        break;
      }
      case 'console-stats-countries':
      case 'console-stats-countries-japan-sales': {
        if (!Array.isArray(gsdDevicesFlatten)) break;
        const gsdDevicesFlattenValues = gsdDevicesFlatten.map(
          (item) => item?.value,
        );
        defaultFormData = {
          ...defaultFormData,
          download_devices_gsd: gsdDevicesFlattenValues,
        };
        break;
      }
      case 'overlap-mobile-games': {
        const startDate = tableParams?.start_date || '';
        const endDate = tableParams?.end_date || '';
        const markets = tableParams?.markets;
        defaultFormData = {
          ...defaultFormData,
          dateRange: [startDate, endDate],
          download_markets: markets?.length
            ? markets
            : defaultFormData?.download_markets,
          start_date: startDate,
          end_date: endDate,
          isDisableRatioSwitch:
            !defaultFormData?.metrics?.includes('mau') || false,
        };
        break;
      }
      case 'mobile-store-rank-more':
      case 'mobile-store-rank-top':
      case 'console-store-rank-more':
      case 'console-ps-store-rank-top':
      case 'console-xbox-store-rank-top':
      case 'console-nintendo-store-rank-top':
      case 'pc-steam-store-rank-top':
      case 'pc-epic-store-rank-top': {
        const date = tableParams?.start_date || tableParams?.end_date;
        const dateM = date ? moment(date) : null;
        const isDateMValid = !!dateM?.isValid();
        const startDate = isDateMValid
          ? dateM?.format('YYYY-MM-DD')
          : tableParams?.start_date || defaultFormData?.dateRange?.[0] || '';
        const endDate = isDateMValid
          ? dateM?.format('YYYY-MM-DD')
          : tableParams?.end_date || defaultFormData?.dateRange?.[1] || startDate;

        defaultFormData = {
          ...defaultFormData,
          dateRange: [startDate, endDate],
          start_date: startDate,
          end_date: endDate,
          sources: tableParams?.rankingSources || defaultFormData?.sources || [],
        };
        break;
      }
      case 'weixin-store-rank-more': {
        const date = tableParams?.start_date || '';
        const dateM = date ? moment(date) : null;
        const dateEnd = tableParams?.end_date || '';
        const dateEndM = dateEnd ? moment(dateEnd) : null;

        const isDateMValid = !!dateM?.isValid();
        const isDateEndMValid = !!dateEndM?.isValid();
        const startDate = isDateMValid
          ? dateM?.format('YYYY-MM-DD')
          : defaultFormData?.start_date;
        const endDate = isDateEndMValid
          ? dateEndM?.format('YYYY-MM-DD')
          : defaultFormData?.end_date;

        defaultFormData = {
          ...defaultFormData,
          dateRange: [startDate, endDate],
          start_date: startDate,
          end_date: endDate,
          dynamicText: props?.texts?.top,
        };
        break;
      }
      case 'minigame-details-store-rank': {
        const startDate = tableParams?.start_date || defaultFormData?.dateRange?.[0] || '';
        const endDate = tableParams?.end_date || defaultFormData?.dateRange?.[1] || startDate;
        defaultFormData = {
          ...defaultFormData,
          dateRange: [startDate, endDate],
          start_date: startDate,
          end_date: endDate,
          minigame_types:
            tableParams?.minigame_types || defaultFormData?.minigame_types || [],
        };
        break;
      }
      case 'pc-details-store-rank': {
        const initialSource = (() => {
          const defaultSources = defaultFormData?.source;
          const platform = tableParams?.platform || '';

          if (isEmpty(defaultSources)) {
            return [];
          }

          if (isEmpty(platform)) {
            return defaultSources;
          }

          return platform ? [platform] : defaultSources;
        })();

        defaultFormData = {
          ...defaultFormData,
          source: initialSource,
        };
        break;
      }
      case 'console-details-store-rank': {
        const initialSourceType = (() => {
          const defaultSources = defaultFormData?.source_type;
          const platform = tableParams?.platform || '';
          const platformAlias: IRecord<string> = {
            playstation: 'play_station',
          };

          if (isEmpty(defaultSources)) {
            return [];
          }

          if (isEmpty(platform)) {
            return defaultSources;
          }

          const platformNew = platformAlias[platform] || platform;

          return platformNew ? [platformNew] : defaultSources;
        })();

        defaultFormData = {
          ...defaultFormData,
          source_type: initialSourceType,
        };
        break;
      }
      default:
        break;
    }
    setFormModelState(defaultFormData);
  }, [businessType, tableParams, visible, gsdDevicesFlatten, formListProcessed]);

  const combineDetailDownloadSyncKey = useMemo(() => {
    if (!['allMetrics', 'consoleData'].includes(tableParams?.currentMetric)) {
      return '';
    }
    return JSON.stringify({
      metrics: tableParams?.metrics,
      source_metrics: tableParams?.source_metrics,
    });
  }, [
    tableParams?.currentMetric,
    tableParams?.metrics,
    tableParams?.source_metrics,
  ]);

  useEffect(() => {
    if (
      !['combine-detail-allmetrics', 'combine-detail-consoledata'].includes(
        businessType,
      ) ||
      !visible ||
      !combineDetailDownloadSyncKey
    ) {
      return;
    }
    const metrics = getAllMetricsDeatilDefaultMetrics(
      tableParams?.source_metrics,
      formListProcessed,
      tableParams?.metrics,
    );
    setFormModelState((prev) => ({
      ...prev,
      metrics,
    }));
  }, [
    businessType,
    visible,
    combineDetailDownloadSyncKey,
    formListProcessed,
    tableParams?.metrics,
    tableParams?.source_metrics,
  ]);

  return (
    <Modal
      visible={visible}
      size={downloadModalSize}
      onClose={handleCloseModal}
      className={`dbi-download-type ${classModalName || ''}`}
      caption={
        <div className="download-head">
          <span>{downloadTitle}</span>
          {downloadTitleTips && (
            <TipContext
              className="tip-text-hd"
              tipText={formatMessage({ id: downloadTitleTips })}
            />
          )}
        </div>
      }
    >
      <Modal.Body>
        <Form
          className={`dbi-download-form teaui-form-alignment ${businessType || ''
            }`}
        >
          <CustomForm
            formList={formList}
            formModel={formModel}
            onChange={handleFormChange}
            tableParams={tableParams}
            businessType={businessType}
            setFormModelState={setFormModelState}
            disabledGsd={disabledGsd}
            disabledFamitsu={disabledFamitsu}
            disabledNpd={disabledNpd}
            disabledRatio={disabledRatio}
            disabledMscience={disabledMscience}
            texts={texts}
            translater={formatMessageSafelyAuto}
            regionOptions={regionOptions}
            pageId={pageId}
            locale={locale}
            isStudio={isStudio}
            isCalibrated={isCalibrated}
          />

          {!isDisableDataAmount && (
            <Form.Item
              label={formatMessage({ id: 'dbi_label_data_amount' })}
              showStatusIcon={false}
            >
              <AutoFormControlText
                options={DATA_AMOUNTS_LIST}
                translater={formatMessageSafelyAuto}
                formControlRenderer={() => (
                  <Radio.Group
                    value={formModel?.data_method}
                    onChange={(value) => {
                      // setFormModelState({ data_method: value });
                      setIsBlur(false);
                      setFormModelState({
                        data_method: value,
                        data_amount: initialSelectTop,
                      });
                    }}
                  >
                    {DATA_AMOUNTS_LIST?.map((item) => (
                      <>
                        <Radio key={item?.value} name={item?.value}>
                          {formatMessage({ id: item?.label })}
                          {isShowExportAllDataTip &&
                            item?.label === 'dbi_export_all_data' && (
                              <TipContext
                                className="dbi-tip-icon dbi-export-all-tip"
                                AWidth={381}
                                tipText={formatMessage({
                                  id: 'dbi_export_all_tip',
                                })}
                              />
                            )}
                        </Radio>
                      </>
                    ))}
                  </Radio.Group>
                )}
              />
            </Form.Item>
          )}

          {isShowDownloadAmountType && (
            <Form.Item
              label={formatMessage({ id: 'dbi_label_download_type' })}
              showStatusIcon={false}
            >
              <Radio.Group
                value={formModel?.select_top_type}
                onChange={(value) => {
                  setFormModelState({ select_top_type: value });
                }}
              >
                {DOWNLOAD_AMOUNT_TYPE_LIST?.map((item) => (
                  <Radio key={item?.value} name={item?.value}>
                    <span className="dbi-download-type-option">
                      {formatMessage({ id: item?.label })}
                      <TipContext
                        className="dbi-tip-icon dbi-download-type-option-tip"
                        AWidth={450}
                        tipText={formatMessage({ id: item?.tip })}
                      />
                    </span>
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          )}

          {formModel?.data_method === 'selectTop' &&
            !isDisableDataAmount &&
            !isAllAndChecked && (
              <Form.Item
                label=""
                showStatusIcon={false}
                status={isBlur ? 'error' : 'validating'}
              >
                <InputNumber
                  field="data_amount"
                  value={formModel?.data_amount}
                  total={
                    STORE_RANK_TOP_BUSINESS_TYPES.includes(businessType)
                      ? undefined
                      : total
                  }
                  isAutoAdjustMaxTipWidth={true}
                  onChange={(field, value) => {
                    const valueNum = Number.isNaN(value) ? 0 : value;
                    if (valueNum < 1) {
                      setFormModelState({ data_amount: 0 });
                      setIsBlur(true);
                      return;
                    }
                    setFormModelState({ data_amount: valueNum });
                    if (0 < valueNum) {
                      setIsBlur(false);
                    } else {
                      setFormModelState({ data_amount: initialSelectTop });
                      setIsBlur(true);
                    }
                  }}
                />
              </Form.Item>
            )}

          <Form.Item label={formatMessage({ id: 'dbi_label_file_format' })}>
            <Radio.Group
              value={formModel?.file_format}
              onChange={(value) => {
                setFormModelState({ file_format: value });
              }}
            >
              {FILE_FORMATS?.map((item) => (
                <Radio key={item?.value} name={item?.value}>
                  {item?.label}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
          <Form.Item label="   ">
            {!hideStickText ? (
              <Form.Text style={{ color: '#9f9f9f' }}>
                {stickText ||
                  formatMessage({ id: 'dbi_download_modal_stick_tips' })}
              </Form.Text>
            ) : null}
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          loading={loading}
          disabled={!isFormValid}
          onClick={() => {
            void handleDownload();
          }}
        >
          {formatMessage({ id: 'dbi_confirm' })}
        </Button>
        <Button type="weak" onClick={handleCloseModal}>
          {formatMessage({ id: 'dbi_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DownloadSettingModal;
